
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
.btn {
  display:flex;
  cursor:pointer;
  align-items:center;
  border-radius:10px;
  border-width:0px;
  font-weight:var(--fw-semibold);
  line-height:1.25;
  text-decoration-line:none;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:300ms;
  min-width:44px;
}
  .btn:focus{
    outline-width:1px;
    outline-style:dashed;
    outline-offset:4px;
  }
  .btn:not(.cta-dark, .cta-light) {
  background-color:var(--bh-neutral-light);
}
  .btn:not(.cta-dark, .cta-light) {
  color:var(--bh-neutral-white);
}
  .btn:not(.cta-dark, .cta-light):hover, .btn:not(.cta-dark, .cta-light):focus {
  background-color:var(--bh-neutral-default);
}
  .btn:not(.cta-dark, .cta-light):focus {
  outline-color:var(--bh-neutral-default);
}

.btn.parent-container-fit {
  display:flex;
  height:100%;
  width:100%;
  justify-content:center;
}

.btn.parent-container-fit .left, .btn.parent-container-fit .right {
  margin-bottom:0px;
  display:flex;
  flex-direction:column;
  justify-content:center;
  padding-top:0px;
}

.btn.parent-container-fit.justify-between{
  justify-content:space-between;
}

.btn.border-bottom-radius {
  border-bottom-left-radius:0px;
  border-bottom-right-radius:0px;
}

.btn ghs-icon {
  position:relative;
  margin-left:0.5rem;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:300ms;
}

.btn.chip {
  border-radius:0.375rem;
  border-width:1px;
  border-style:solid;
  font-weight:var(--fw-normal);
}

.btn.chip .right ghs-icon {
  margin-left:0px;
}

.btn.chip:focus {
  outline-style:solid;
}

.btn.chip:focus {
  outline-width:2px;
}

.btn.chip.small {
  height:30px;
}

.btn.chip.small {
  padding-left:0.375rem;
  padding-right:0.375rem;
}

.btn.chip.small {
  padding-top:0.25rem;
  padding-bottom:0.25rem;
}

.btn.chip.small .right {
  padding-left:0.5rem;
}

.btn.chip.medium {
  height:37px;
}

.btn.chip.medium {
  padding-left:0.5rem;
  padding-right:0.5rem;
}

.btn.chip.medium .right {
  padding-left:0.625rem;
}

.btn.chip.large {
  height:43px;
}

.btn.chip.large {
  padding-left:1rem;
  padding-right:1rem;
}

.btn.chip.large .right {
  padding-left:0.75rem;
}

.btn.none {
  display:flex;
  align-items:center;
  padding-left:1rem;
  padding-right:1rem;
  font-size:var(--fs-base);
  line-height:var(--lh-base);
}

.left {
  display:flex;
  height:100%;
  align-items:center;
  padding-right:0.5rem;
}

.top {
  display:flex;
  height:100%;
  align-items:center;
  padding-right:0.5rem;
  padding-bottom:0.5rem;
}

.right {
  display:flex;
  height:100%;
  align-items:center;
  padding-left:0.5rem;
}

.btn[aria-disabled='true'] {
  pointer-events:none !important;
  cursor:not-allowed !important;
  background-color:var(--neutral-gray-4) !important;
  color:var(--neutral-gray-1) !important;
}

.btn.small {
  max-height:45px;
  padding-left:1rem;
  padding-right:1rem;
  padding-top:0.75rem;
  padding-bottom:0.75rem;
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
}

.btn.medium {
  max-height:55px;
  padding-left:1rem;
  padding-right:1rem;
  padding-top:0.75rem;
  padding-bottom:0.75rem;
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
}

.btn.large {
  min-height:45px;
  padding-left:1.25rem;
  padding-right:1.25rem;
  padding-top:0.75rem;
  padding-bottom:0.75rem;
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
}

@media (min-width: 768px) {
  .btn.large {
    min-height:max-content;
  }
  .btn.large {
    padding-left:2rem;
    padding-right:2rem;
  }
  .btn.large {
    padding-top:1rem;
    padding-bottom:1rem;
  }
  .btn.large {
    font-size:var(--fs-lg);
    line-height:var(--lh-lg);
  }
}

.btn.xl {
  padding-left:1.25rem;
  padding-right:1.25rem;
  padding-top:0.75rem;
  padding-bottom:0.75rem;
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
  font-weight:var(--fw-light);
}

@media (min-width: 768px) {
  .btn.xl {
    min-height:max-content;
  }
  .btn.xl {
    padding-left:2rem;
    padding-right:2rem;
  }
  .btn.xl {
    padding-top:1rem;
    padding-bottom:1rem;
  }
  .btn.xl {
    font-size:var(--fs-xl);
    line-height:var(--lh-xl);
  }
}

.btn.cta-dark.small, .btn.cta-light.small, .btn.cta-dark.large, .btn.cta-light.large {
  padding:0px;
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
  min-height:auto;
}

.btn:has(> .top) {
  flex-direction:column;
  align-items:center;
  text-align:center;
}

[site='GHS'] .btn, :host([site='GHS']) .btn {
  font-family:var(--ff-display);
}

[site='GHS'] .btn.primary, [site='GHS'] .btn.secondary, [site='GHS'] .btn.tertiary, [site='GHS'] .btn.quaternary, :host([site='GHS']) .btn.primary, :host([site='GHS']) .btn.secondary, :host([site='GHS']) .btn.tertiary, :host([site='GHS']) .btn.quaternary {
  transition-property:box-shadow;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:150ms;
}

[site='GHS'] .btn.primary:hover, [site='GHS'] .btn.secondary:hover, [site='GHS'] .btn.tertiary:hover, [site='GHS'] .btn.quaternary:hover, :host([site='GHS']) .btn.primary:hover, :host([site='GHS']) .btn.secondary:hover, :host([site='GHS']) .btn.tertiary:hover, :host([site='GHS']) .btn.quaternary:hover{
      box-shadow:var(--brand-shadow-sm);
    }

[site='GHS'] .btn.primary, :host([site='GHS']) .btn.primary {
  background-color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.primary, :host([site='GHS']) .btn.primary {
  color:var(--neutral-white);
}

[site='GHS'] .btn.primary:hover, [site='GHS'] .btn.primary:focus, :host([site='GHS']) .btn.primary:hover, :host([site='GHS']) .btn.primary:focus {
  background-color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.primary:hover, [site='GHS'] .btn.primary:focus, :host([site='GHS']) .btn.primary:hover, :host([site='GHS']) .btn.primary:focus {
  color:var(--neutral-white);
}

[site='GHS'] .btn.primary:focus, :host([site='GHS']) .btn.primary:focus {
  outline-color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.secondary, :host([site='GHS']) .btn.secondary {
  background-color:var(--primary-green);
}

[site='GHS'] .btn.secondary, :host([site='GHS']) .btn.secondary {
  color:var(--neutral-white);
}

[site='GHS'] .btn.secondary:hover, [site='GHS'] .btn.secondary:focus, :host([site='GHS']) .btn.secondary:hover, :host([site='GHS']) .btn.secondary:focus {
  background-color:var(--primary-green);
}

[site='GHS'] .btn.secondary:hover, [site='GHS'] .btn.secondary:focus, :host([site='GHS']) .btn.secondary:hover, :host([site='GHS']) .btn.secondary:focus {
  color:var(--neutral-white);
}

[site='GHS'] .btn.secondary:focus, :host([site='GHS']) .btn.secondary:focus {
  outline-color:var(--primary-green);
}

[site='GHS'] .btn.tertiary, :host([site='GHS']) .btn.tertiary {
  background-color:var(--neutral-white);
}

[site='GHS'] .btn.tertiary, :host([site='GHS']) .btn.tertiary {
  color:var(--primary-blue);
}

[site='GHS'] .btn.tertiary:focus, :host([site='GHS']) .btn.tertiary:focus {
  outline-color:var(--neutral-white);
}

[site='GHS'] .btn.cta-dark, :host([site='GHS']) .btn.cta-dark {
  background-color:var(--neutral-transparent);
}

[site='GHS'] .btn.cta-dark, :host([site='GHS']) .btn.cta-dark {
  text-align:left;
}

[site='GHS'] .btn.cta-dark, :host([site='GHS']) .btn.cta-dark {
  color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.cta-dark:hover, [site='GHS'] .btn.cta-dark:focus, :host([site='GHS']) .btn.cta-dark:hover, :host([site='GHS']) .btn.cta-dark:focus {
  background-color:var(--neutral-transparent);
}

[site='GHS'] .btn.cta-dark:hover, [site='GHS'] .btn.cta-dark:focus, :host([site='GHS']) .btn.cta-dark:hover, :host([site='GHS']) .btn.cta-dark:focus {
  color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.cta-dark:hover, [site='GHS'] .btn.cta-dark:focus, :host([site='GHS']) .btn.cta-dark:hover, :host([site='GHS']) .btn.cta-dark:focus {
  text-decoration-line:underline;
}

[site='GHS'] .btn.cta-dark:focus, :host([site='GHS']) .btn.cta-dark:focus {
  outline-color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.cta-light, :host([site='GHS']) .btn.cta-light {
  background-color:var(--neutral-transparent);
}

[site='GHS'] .btn.cta-light, :host([site='GHS']) .btn.cta-light {
  text-align:left;
}

[site='GHS'] .btn.cta-light, :host([site='GHS']) .btn.cta-light {
  color:var(--neutral-white);
}

[site='GHS'] .btn.cta-light:hover, [site='GHS'] .btn.cta-light:focus, :host([site='GHS']) .btn.cta-light:hover, :host([site='GHS']) .btn.cta-light:focus {
  background-color:var(--neutral-transparent);
}

[site='GHS'] .btn.cta-light:hover, [site='GHS'] .btn.cta-light:focus, :host([site='GHS']) .btn.cta-light:hover, :host([site='GHS']) .btn.cta-light:focus {
  color:var(--neutral-white);
}

[site='GHS'] .btn.cta-light:hover, [site='GHS'] .btn.cta-light:focus, :host([site='GHS']) .btn.cta-light:hover, :host([site='GHS']) .btn.cta-light:focus {
  text-decoration-line:underline;
}

[site='GHS'] .btn.cta-light:focus, :host([site='GHS']) .btn.cta-light:focus {
  outline-color:var(--neutral-white);
}

[site='GHS'] .btn.quaternary, :host([site='GHS']) .btn.quaternary {
  background-color:var(--neutral-white);
}

[site='GHS'] .btn.quaternary.border-white, :host([site='GHS']) .btn.quaternary.border-white {
  border-width:1px;
}

[site='GHS'] .btn.quaternary.border-white, :host([site='GHS']) .btn.quaternary.border-white {
  border-style:solid;
}

[site='GHS'] .btn.quaternary.border-white, :host([site='GHS']) .btn.quaternary.border-white {
  border-color:var(--neutral-white);
}

[site='GHS'] .btn.quaternary.border-white:focus, :host([site='GHS']) .btn.quaternary.border-white:focus {
  outline-color:var(--neutral-white);
}

[site='GHS'] .btn.quaternary.border-blue, :host([site='GHS']) .btn.quaternary.border-blue {
  border-width:1px;
}

[site='GHS'] .btn.quaternary.border-blue, :host([site='GHS']) .btn.quaternary.border-blue {
  border-style:solid;
}

[site='GHS'] .btn.quaternary.border-blue, :host([site='GHS']) .btn.quaternary.border-blue {
  border-color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.quaternary.border-blue, :host([site='GHS']) .btn.quaternary.border-blue {
  color:var(--primary-blue);
}

[site='GHS'] .btn.quaternary.border-blue:focus, :host([site='GHS']) .btn.quaternary.border-blue:focus {
  outline-color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.quaternary.border-magenta, :host([site='GHS']) .btn.quaternary.border-magenta {
  border-width:1px;
}

[site='GHS'] .btn.quaternary.border-magenta, :host([site='GHS']) .btn.quaternary.border-magenta {
  border-style:solid;
}

[site='GHS'] .btn.quaternary.border-magenta, :host([site='GHS']) .btn.quaternary.border-magenta {
  border-color:var(--tertiary-magenta);
}

[site='GHS'] .btn.quaternary.border-magenta, :host([site='GHS']) .btn.quaternary.border-magenta {
  color:var(--tertiary-magenta);
}

[site='GHS'] .btn.quaternary.border-magenta:focus, :host([site='GHS']) .btn.quaternary.border-magenta:focus {
  outline-color:var(--tertiary-magenta);
}

[site='GHS'] .btn.quaternary.border-green, :host([site='GHS']) .btn.quaternary.border-green {
  border-width:1px;
}

[site='GHS'] .btn.quaternary.border-green, :host([site='GHS']) .btn.quaternary.border-green {
  border-style:solid;
}

[site='GHS'] .btn.quaternary.border-green, :host([site='GHS']) .btn.quaternary.border-green {
  border-color:var(--primary-green);
}

[site='GHS'] .btn.quaternary.border-green, :host([site='GHS']) .btn.quaternary.border-green {
  color:var(--primary-green);
}

[site='GHS'] .btn.quaternary.border-green:focus, :host([site='GHS']) .btn.quaternary.border-green:focus {
  outline-color:var(--primary-green);
}

[site='GHS'] .btn.tertiary.text-white, :host([site='GHS']) .btn.tertiary.text-white {
  color:var(--neutral-white);
}

[site='GHS'] .btn.tertiary.text-blue, :host([site='GHS']) .btn.tertiary.text-blue {
  color:var(--primary-blue-light-2);
}

[site='GHS'] .btn.tertiary.text-magenta, :host([site='GHS']) .btn.tertiary.text-magenta {
  color:var(--tertiary-magenta);
}

[site='GHS'] .btn.tertiary.text-green, :host([site='GHS']) .btn.tertiary.text-green {
  color:var(--primary-green);
}

[site='GHS'] .btn.primary.border-square, :host([site='GHS']) .btn.primary.border-square {
  min-height:6.5rem;
}

[site='GHS'] .btn.primary.border-square, :host([site='GHS']) .btn.primary.border-square {
  border-radius:0px;
}

[site='GHS'] .btn.primary.border-square, :host([site='GHS']) .btn.primary.border-square {
  border-width:2px;
}

[site='GHS'] .btn.primary.border-square, :host([site='GHS']) .btn.primary.border-square {
  border-style:solid;
}

[site='GHS'] .btn.primary.border-square, :host([site='GHS']) .btn.primary.border-square {
  border-color:var(--neutral-white);
}

[site='GHS'] .btn.primary.border-square, :host([site='GHS']) .btn.primary.border-square {
  background-color:var(--primary-blue);
}

@media (min-width: 768px) {
  [site='GHS'] .btn.primary.border-square, :host([site='GHS']) .btn.primary.border-square {
    min-height:7.5rem;
  }
}

[site='GHS'] .btn.primary.border-square:hover, :host([site='GHS']) .btn.primary.border-square:hover {
  text-decoration-line:underline;
}

[site='BH'] .btn.primary, [site='BH'] .btn.secondary, [site='BH'] .btn.tertiary, [site='BH'] .btn.quaternary, [site='BH'] .btn.cta-dark, [site='BH'] .btn.cta-light, [site='BH'] .btn.chip, [site='BH'] .btn.emplify, [site='BH'] .btn.emplifynew, :host([site='BH']) .btn.primary, :host([site='BH']) .btn.secondary, :host([site='BH']) .btn.tertiary, :host([site='BH']) .btn.quaternary, :host([site='BH']) .btn.cta-dark, :host([site='BH']) .btn.cta-light, :host([site='BH']) .btn.chip, :host([site='BH']) .btn.emplify, :host([site='BH']) .btn.emplifynew {
  font-family:var(--bh-ff-body);
}

[site='BH'] .btn.primary, [site='BH'] .btn.secondary, [site='BH'] .btn.tertiary, [site='BH'] .btn.quaternary, [site='BH'] .btn.cta-dark, [site='BH'] .btn.cta-light, [site='BH'] .btn.chip, [site='BH'] .btn.emplify, [site='BH'] .btn.emplifynew, :host([site='BH']) .btn.primary, :host([site='BH']) .btn.secondary, :host([site='BH']) .btn.tertiary, :host([site='BH']) .btn.quaternary, :host([site='BH']) .btn.cta-dark, :host([site='BH']) .btn.cta-light, :host([site='BH']) .btn.chip, :host([site='BH']) .btn.emplify, :host([site='BH']) .btn.emplifynew {
  font-size:var(--bh-fs-body-02);
  line-height:var(--bh-lh-body-02);
  letter-spacing:var(--bh-ls-body-02);
}

[site='BH'] .btn.primary.xl, [site='BH'] .btn.secondary.xl, [site='BH'] .btn.tertiary.xl, [site='BH'] .btn.quaternary.xl, [site='BH'] .btn.cta-dark.xl, [site='BH'] .btn.cta-light.xl, [site='BH'] .btn.chip.xl, [site='BH'] .btn.emplify.xl, [site='BH'] .btn.emplifynew.xl, :host([site='BH']) .btn.primary.xl, :host([site='BH']) .btn.secondary.xl, :host([site='BH']) .btn.tertiary.xl, :host([site='BH']) .btn.quaternary.xl, :host([site='BH']) .btn.cta-dark.xl, :host([site='BH']) .btn.cta-light.xl, :host([site='BH']) .btn.chip.xl, :host([site='BH']) .btn.emplify.xl, :host([site='BH']) .btn.emplifynew.xl {
  font-weight:var(--fw-light);
}

[site='BH'] .btn.primary.xl, [site='BH'] .btn.secondary.xl, [site='BH'] .btn.tertiary.xl, [site='BH'] .btn.quaternary.xl, [site='BH'] .btn.cta-dark.xl, [site='BH'] .btn.cta-light.xl, [site='BH'] .btn.chip.xl, [site='BH'] .btn.emplify.xl, [site='BH'] .btn.emplifynew.xl, :host([site='BH']) .btn.primary.xl, :host([site='BH']) .btn.secondary.xl, :host([site='BH']) .btn.tertiary.xl, :host([site='BH']) .btn.quaternary.xl, :host([site='BH']) .btn.cta-dark.xl, :host([site='BH']) .btn.cta-light.xl, :host([site='BH']) .btn.chip.xl, :host([site='BH']) .btn.emplify.xl, :host([site='BH']) .btn.emplifynew.xl{
      font-size:clamp(1.5rem, calc(0rem + 3.13vw), 2rem);
      line-height:110%;
      letter-spacing:-0.16px;
    }

[site='BH'] .btn.primary, [site='BH'] .btn.secondary, [site='BH'] .btn.tertiary, [site='BH'] .btn.quaternary, [site='BH'] .btn.cta-dark, [site='BH'] .btn.cta-light, :host([site='BH']) .btn.primary, :host([site='BH']) .btn.secondary, :host([site='BH']) .btn.tertiary, :host([site='BH']) .btn.quaternary, :host([site='BH']) .btn.cta-dark, :host([site='BH']) .btn.cta-light {
  font-weight:var(--fw-bold);
}

[site='BH'] .btn.primary, :host([site='BH']) .btn.primary {
  background-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.primary, :host([site='BH']) .btn.primary {
  color:var(--bh-neutral-white);
}

[site='BH'] .btn.primary:hover, [site='BH'] .btn.primary:focus, :host([site='BH']) .btn.primary:hover, :host([site='BH']) .btn.primary:focus {
  background-color:var(--bh-brand-primary-dark);
}

[site='BH'] .btn.primary:focus, :host([site='BH']) .btn.primary:focus {
  outline-style:solid;
}

[site='BH'] .btn.primary:focus, :host([site='BH']) .btn.primary:focus {
  outline-width:2px;
}

[site='BH'] .btn.primary:focus, :host([site='BH']) .btn.primary:focus {
  outline-color:var(--bh-brand-primary-dark);
}

[site='BH'] .btn.primary:active, :host([site='BH']) .btn.primary:active {
  background-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.primary:active, :host([site='BH']) .btn.primary:active{
      box-shadow:0px 3px 2px 0px #00000040 inset;
    }

[site='BH'] .btn.primary[aria-disabled='true'], :host([site='BH']) .btn.primary[aria-disabled='true'] {
  background-color:var(--bh-neutral-dark) !important;
}

[site='BH'] .btn.primary[aria-disabled='true'], :host([site='BH']) .btn.primary[aria-disabled='true'] {
  color:var(--bh-neutral-white) !important;
}

[site='BH'] .btn.secondary, :host([site='BH']) .btn.secondary {
  border-width:2px;
}

[site='BH'] .btn.secondary, :host([site='BH']) .btn.secondary {
  border-style:solid;
}

[site='BH'] .btn.secondary, :host([site='BH']) .btn.secondary {
  border-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.secondary, :host([site='BH']) .btn.secondary {
  background-color:var(--neutral-transparent);
}

[site='BH'] .btn.secondary, :host([site='BH']) .btn.secondary {
  color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.secondary:hover, [site='BH'] .btn.secondary:focus, :host([site='BH']) .btn.secondary:hover, :host([site='BH']) .btn.secondary:focus {
  background-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.secondary:hover, [site='BH'] .btn.secondary:focus, :host([site='BH']) .btn.secondary:hover, :host([site='BH']) .btn.secondary:focus {
  color:var(--bh-neutral-white);
}

[site='BH'] .btn.secondary:focus, :host([site='BH']) .btn.secondary:focus {
  outline-style:solid;
}

[site='BH'] .btn.secondary:focus, :host([site='BH']) .btn.secondary:focus {
  outline-width:2px;
}

[site='BH'] .btn.secondary:focus, :host([site='BH']) .btn.secondary:focus {
  outline-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.secondary:active, :host([site='BH']) .btn.secondary:active {
  background-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.secondary:active, :host([site='BH']) .btn.secondary:active{
      box-shadow:0px 3px 2px 0px #00000040 inset;
    }

[site='BH'] .btn.secondary[aria-disabled='true'], :host([site='BH']) .btn.secondary[aria-disabled='true'] {
  border-color:var(--bh-neutral-dark) !important;
}

[site='BH'] .btn.secondary[aria-disabled='true'], :host([site='BH']) .btn.secondary[aria-disabled='true'] {
  background-color:var(--neutral-transparent) !important;
}

[site='BH'] .btn.secondary[aria-disabled='true'], :host([site='BH']) .btn.secondary[aria-disabled='true'] {
  color:var(--bh-neutral-dark) !important;
}

[site='BH'] .btn.tertiary, :host([site='BH']) .btn.tertiary {
  background-color:var(--bh-neutral-white);
}

[site='BH'] .btn.tertiary, :host([site='BH']) .btn.tertiary {
  color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.tertiary:hover, [site='BH'] .btn.tertiary:focus, [site='BH'] .btn.tertiary:active, :host([site='BH']) .btn.tertiary:hover, :host([site='BH']) .btn.tertiary:focus, :host([site='BH']) .btn.tertiary:active {
  color:var(--bh-brand-primary-dark);
}

[site='BH'] .btn.tertiary:hover, :host([site='BH']) .btn.tertiary:hover {
  background-color:var(--bh-brand-primary-lighter);
}

[site='BH'] .btn.tertiary:focus, :host([site='BH']) .btn.tertiary:focus {
  outline-style:solid;
}

[site='BH'] .btn.tertiary:focus, :host([site='BH']) .btn.tertiary:focus {
  outline-width:2px;
}

[site='BH'] .btn.tertiary:focus, :host([site='BH']) .btn.tertiary:focus {
  outline-color:var(--bh-neutral-white);
}

[site='BH'] .btn.tertiary:active, :host([site='BH']) .btn.tertiary:active {
  background-color:var(--bh-neutral-white);
}

[site='BH'] .btn.tertiary:active, :host([site='BH']) .btn.tertiary:active{
      box-shadow:0px 3px 2px 0px #00000040 inset;
    }

[site='BH'] .btn.tertiary[aria-disabled='true'], :host([site='BH']) .btn.tertiary[aria-disabled='true'] {
  background-color:var(--bh-neutral-default) !important;
}

[site='BH'] .btn.tertiary[aria-disabled='true'], :host([site='BH']) .btn.tertiary[aria-disabled='true'] {
  color:var(--bh-neutral-darker) !important;
}

[site='BH'] .btn.quaternary, :host([site='BH']) .btn.quaternary {
  border-width:2px;
}

[site='BH'] .btn.quaternary, :host([site='BH']) .btn.quaternary {
  border-style:solid;
}

[site='BH'] .btn.quaternary, :host([site='BH']) .btn.quaternary {
  border-color:var(--bh-neutral-white);
}

[site='BH'] .btn.quaternary, :host([site='BH']) .btn.quaternary {
  background-color:var(--neutral-transparent);
}

[site='BH'] .btn.quaternary, :host([site='BH']) .btn.quaternary {
  color:var(--bh-neutral-white);
}

[site='BH'] .btn.quaternary:focus, :host([site='BH']) .btn.quaternary:focus {
  background-color:var(--neutral-transparent);
}

[site='BH'] .btn.quaternary:focus, :host([site='BH']) .btn.quaternary:focus {
  outline-style:solid;
}

[site='BH'] .btn.quaternary:focus, :host([site='BH']) .btn.quaternary:focus {
  outline-width:2px;
}

[site='BH'] .btn.quaternary:focus, :host([site='BH']) .btn.quaternary:focus {
  outline-color:var(--bh-neutral-white);
}

[site='BH'] .btn.quaternary:hover, [site='BH'] .btn.quaternary:active, :host([site='BH']) .btn.quaternary:hover, :host([site='BH']) .btn.quaternary:active {
  border-color:var(--bh-brand-primary-darker);
}

[site='BH'] .btn.quaternary:hover, [site='BH'] .btn.quaternary:active, :host([site='BH']) .btn.quaternary:hover, :host([site='BH']) .btn.quaternary:active {
  background-color:var(--bh-brand-primary-darker);
}

[site='BH'] .btn.quaternary:active, :host([site='BH']) .btn.quaternary:active{
      box-shadow:0px 3px 2px 0px #00000040 inset;
    }

[site='BH'] .btn.quaternary[aria-disabled='true'], :host([site='BH']) .btn.quaternary[aria-disabled='true'] {
  border-color:var(--bh-neutral-default) !important;
}

[site='BH'] .btn.quaternary[aria-disabled='true'], :host([site='BH']) .btn.quaternary[aria-disabled='true'] {
  background-color:var(--neutral-transparent) !important;
}

[site='BH'] .btn.quaternary[aria-disabled='true'], :host([site='BH']) .btn.quaternary[aria-disabled='true'] {
  color:var(--bh-neutral-default) !important;
}

[site='BH'] .btn.cta-dark, :host([site='BH']) .btn.cta-dark {
  color:var(--bh-brand-primary-default-compatibility);
}

[site='BH'] .btn.cta-dark:hover, [site='BH'] .btn.cta-dark:active, [site='BH'] .btn.cta-dark:focus, :host([site='BH']) .btn.cta-dark:hover, :host([site='BH']) .btn.cta-dark:active, :host([site='BH']) .btn.cta-dark:focus {
  color:var(--bh-brand-primary-dark);
}

[site='BH'] .btn.cta-dark:hover, [site='BH'] .btn.cta-dark:active, [site='BH'] .btn.cta-dark:focus, :host([site='BH']) .btn.cta-dark:hover, :host([site='BH']) .btn.cta-dark:active, :host([site='BH']) .btn.cta-dark:focus {
  text-decoration-line:underline;
}

[site='BH'] .btn.cta-dark:focus, :host([site='BH']) .btn.cta-dark:focus {
  outline-style:solid;
}

[site='BH'] .btn.cta-dark:focus, :host([site='BH']) .btn.cta-dark:focus {
  outline-width:2px;
}

[site='BH'] .btn.cta-dark:focus, :host([site='BH']) .btn.cta-dark:focus {
  outline-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.cta-dark[aria-disabled='true'], :host([site='BH']) .btn.cta-dark[aria-disabled='true'] {
  background-color:var(--neutral-transparent) !important;
}

[site='BH'] .btn.cta-dark[aria-disabled='true'], :host([site='BH']) .btn.cta-dark[aria-disabled='true'] {
  color:var(--bh-neutral-dark) !important;
}

[site='BH'] .btn.cta-light, :host([site='BH']) .btn.cta-light {
  color:var(--bh-neutral-white);
}

[site='BH'] .btn.cta-light:hover, [site='BH'] .btn.cta-light:active, [site='BH'] .btn.cta-light:focus, :host([site='BH']) .btn.cta-light:hover, :host([site='BH']) .btn.cta-light:active, :host([site='BH']) .btn.cta-light:focus {
  text-decoration-line:underline;
}

[site='BH'] .btn.cta-light:focus, :host([site='BH']) .btn.cta-light:focus {
  outline-style:solid;
}

[site='BH'] .btn.cta-light:focus, :host([site='BH']) .btn.cta-light:focus {
  outline-width:2px;
}

[site='BH'] .btn.cta-light:focus, :host([site='BH']) .btn.cta-light:focus {
  outline-color:var(--bh-neutral-white);
}

[site='BH'] .btn.cta-light[aria-disabled='true'], :host([site='BH']) .btn.cta-light[aria-disabled='true'] {
  background-color:var(--neutral-transparent) !important;
}

[site='BH'] .btn.cta-light[aria-disabled='true'], :host([site='BH']) .btn.cta-light[aria-disabled='true'] {
  color:var(--bh-neutral-default) !important;
}

[site='BH'] .btn.chip, :host([site='BH']) .btn.chip {
  border-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.chip, :host([site='BH']) .btn.chip {
  background-color:var(--neutral-transparent);
}

[site='BH'] .btn.chip, :host([site='BH']) .btn.chip {
  color:var(--bh-neutral-darker);
}

[site='BH'] .btn.chip:hover, :host([site='BH']) .btn.chip:hover {
  border-color:var(--bh-brand-primary-darker);
}

[site='BH'] .btn.chip:hover, :host([site='BH']) .btn.chip:hover {
  background-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.chip:hover, :host([site='BH']) .btn.chip:hover {
  color:var(--bh-neutral-white);
}

[site='BH'] .btn.chip:focus, :host([site='BH']) .btn.chip:focus {
  outline-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.chip:active, :host([site='BH']) .btn.chip:active {
  background-color:var(--bh-brand-primary-default);
}

[site='BH'] .btn.chip:active, :host([site='BH']) .btn.chip:active{
      box-shadow:0px 3px 2px 0px #00000040 inset;
    }

[site='BH'] .btn.chip[aria-disabled='true'], :host([site='BH']) .btn.chip[aria-disabled='true'] {
  border-color:var(--bh-neutral-default) !important;
}

[site='BH'] .btn.chip[aria-disabled='true'], :host([site='BH']) .btn.chip[aria-disabled='true'] {
  background-color:var(--bh-neutral-lighter) !important;
}

[site='BH'] .btn.chip[aria-disabled='true'], :host([site='BH']) .btn.chip[aria-disabled='true'] {
  color:var(--bh-neutral-dark) !important;
}

[site='BH'] .btn.emplify, :host([site='BH']) .btn.emplify, [site='GHS'] .btn.emplify, :host([site='GHS']) .btn.emplify {
  color:var(--eh-brand-primary);
}

[site='BH'] .btn.emplify, :host([site='BH']) .btn.emplify, [site='GHS'] .btn.emplify, :host([site='GHS']) .btn.emplify {
  background-color:var(--eh-brand-secondary-100);
}

[site='BH'] .btn.emplify:hover, [site='BH'] .btn.emplify:focus, :host([site='BH']) .btn.emplify:hover, :host([site='BH']) .btn.emplify:focus, [site='GHS'] .btn.emplify:hover, [site='GHS'] .btn.emplify:focus, :host([site='GHS']) .btn.emplify:hover, :host([site='GHS']) .btn.emplify:focus {
  background-color:var(--eh-brand-primary);
}

[site='BH'] .btn.emplify:hover,
    [site='BH'] .btn.emplify:focus,
    :host([site='BH']) .btn.emplify:hover,
    :host([site='BH']) .btn.emplify:focus,
    [site='GHS'] .btn.emplify:hover,
    [site='GHS'] .btn.emplify:focus,
    :host([site='GHS']) .btn.emplify:hover,
    :host([site='GHS']) .btn.emplify:focus{
      color:#fff;
    }

[site='BH'] .btn.emplify:focus, :host([site='BH']) .btn.emplify:focus, [site='GHS'] .btn.emplify:focus, :host([site='GHS']) .btn.emplify:focus {
  outline-color:var(--eh-brand-primary);
}

[site='BH'] .btn.emplify .right:has(> .extra-icon), :host([site='BH']) .btn.emplify .right:has(> .extra-icon), [site='GHS'] .btn.emplify .right:has(> .extra-icon), :host([site='GHS']) .btn.emplify .right:has(> .extra-icon) {
  padding-left:0px;
}

[site='BH'] .btn.emplify .right:has(> .extra-icon) .extra-icon, :host([site='BH']) .btn.emplify .right:has(> .extra-icon) .extra-icon, [site='GHS'] .btn.emplify .right:has(> .extra-icon) .extra-icon, :host([site='GHS']) .btn.emplify .right:has(> .extra-icon) .extra-icon {
  margin-left:0.25rem;
}

@media (min-width: 1024px){
      [site='BH'] .btn.emplify.small, :host([site='BH']) .btn.emplify.small, [site='GHS'] .btn.emplify.small, :host([site='GHS']) .btn.emplify.small {
    margin-top:0.375rem;
    margin-bottom:0.375rem;
  }
    }

[site='BH'] .btn.emplifynew .right:has(> .extra-icon), [site='BH'] .btn.bellinmychart .right:has(> .extra-icon), [site='BH'] .btn.emplifymychart .right:has(> .extra-icon), :host([site='BH']) .btn.emplifynew .right:has(> .extra-icon), :host([site='BH']) .btn.bellinmychart .right:has(> .extra-icon), :host([site='BH']) .btn.emplifymychart .right:has(> .extra-icon), [site='GHS'] .btn.emplifynew .right:has(> .extra-icon), [site='GHS'] .btn.bellinmychart .right:has(> .extra-icon), [site='GHS'] .btn.emplifymychart .right:has(> .extra-icon), :host([site='GHS']) .btn.emplifynew .right:has(> .extra-icon), :host([site='GHS']) .btn.bellinmychart .right:has(> .extra-icon), :host([site='GHS']) .btn.emplifymychart .right:has(> .extra-icon) {
  padding-left:0px;
}

[site='BH'] .btn.emplifynew .right:has(> .extra-icon) .extra-icon, [site='BH'] .btn.bellinmychart .right:has(> .extra-icon) .extra-icon, [site='BH'] .btn.emplifymychart .right:has(> .extra-icon) .extra-icon, :host([site='BH']) .btn.emplifynew .right:has(> .extra-icon) .extra-icon, :host([site='BH']) .btn.bellinmychart .right:has(> .extra-icon) .extra-icon, :host([site='BH']) .btn.emplifymychart .right:has(> .extra-icon) .extra-icon, [site='GHS'] .btn.emplifynew .right:has(> .extra-icon) .extra-icon, [site='GHS'] .btn.bellinmychart .right:has(> .extra-icon) .extra-icon, [site='GHS'] .btn.emplifymychart .right:has(> .extra-icon) .extra-icon, :host([site='GHS']) .btn.emplifynew .right:has(> .extra-icon) .extra-icon, :host([site='GHS']) .btn.bellinmychart .right:has(> .extra-icon) .extra-icon, :host([site='GHS']) .btn.emplifymychart .right:has(> .extra-icon) .extra-icon {
  margin-left:0.25rem;
}

@media (min-width: 1024px){
      [site='BH'] .btn.emplifynew.small, [site='BH'] .btn.bellinmychart.small, [site='BH'] .btn.emplifymychart.small, :host([site='BH']) .btn.emplifynew.small, :host([site='BH']) .btn.bellinmychart.small, :host([site='BH']) .btn.emplifymychart.small, [site='GHS'] .btn.emplifynew.small, [site='GHS'] .btn.bellinmychart.small, [site='GHS'] .btn.emplifymychart.small, :host([site='GHS']) .btn.emplifynew.small, :host([site='GHS']) .btn.bellinmychart.small, :host([site='GHS']) .btn.emplifymychart.small {
    margin-top:0.375rem;
    margin-bottom:0.375rem;
  }
    }

[site='BH'] .btn.emplifynew, :host([site='BH']) .btn.emplifynew, [site='GHS'] .btn.emplifynew, :host([site='GHS']) .btn.emplifynew {
  background-color:var(--eh-brand-primary);
}

[site='BH'] .btn.emplifynew:hover, [site='BH'] .btn.emplifynew:focus, :host([site='BH']) .btn.emplifynew:hover, :host([site='BH']) .btn.emplifynew:focus, [site='GHS'] .btn.emplifynew:hover, [site='GHS'] .btn.emplifynew:focus, :host([site='GHS']) .btn.emplifynew:hover, :host([site='GHS']) .btn.emplifynew:focus {
  color:var(--eh-brand-primary);
}

[site='BH'] .btn.emplifynew:hover,
    [site='BH'] .btn.emplifynew:focus,
    :host([site='BH']) .btn.emplifynew:hover,
    :host([site='BH']) .btn.emplifynew:focus,
    [site='GHS'] .btn.emplifynew:hover,
    [site='GHS'] .btn.emplifynew:focus,
    :host([site='GHS']) .btn.emplifynew:hover,
    :host([site='GHS']) .btn.emplifynew:focus{
      background-color:#fff;
    }

[site='BH'] .btn.bellinmychart, :host([site='BH']) .btn.bellinmychart, [site='GHS'] .btn.bellinmychart, :host([site='GHS']) .btn.bellinmychart{
    background-color:transparent;
    color:#fff;
  }

[site='BH'] .btn.bellinmychart, :host([site='BH']) .btn.bellinmychart, [site='GHS'] .btn.bellinmychart, :host([site='GHS']) .btn.bellinmychart {
  font-weight:var(--fw-bold);
}

[site='BH'] .btn.bellinmychart, :host([site='BH']) .btn.bellinmychart, [site='GHS'] .btn.bellinmychart, :host([site='GHS']) .btn.bellinmychart{
    font-size:var(--fs-xs);
  }

[site='BH'] .btn.emplifymychart, :host([site='BH']) .btn.emplifymychart, [site='GHS'] .btn.emplifymychart, :host([site='GHS']) .btn.emplifymychart{
    background-color:transparent;
  }

[site='BH'] .btn.emplifymychart, :host([site='BH']) .btn.emplifymychart, [site='GHS'] .btn.emplifymychart, :host([site='GHS']) .btn.emplifymychart {
  padding:0px;
}

[site='BH'] .btn.emplifymychart, :host([site='BH']) .btn.emplifymychart, [site='GHS'] .btn.emplifymychart, :host([site='GHS']) .btn.emplifymychart {
  color:var(--eh-brand-primary);
}

[site='BH'] .btn.emplifymychart, :host([site='BH']) .btn.emplifymychart, [site='GHS'] .btn.emplifymychart, :host([site='GHS']) .btn.emplifymychart{
    font-size:var(--fs-sm);
  }

.header-submenu nav > ul {
  display:block;
}

@media (min-width: 1024px) {
  .header-submenu nav > ul {
    display:flex;
  }
}

@media (min-width: 1024px) {
  .header-submenu nav > ul {
    justify-content:space-between;
  }
}

.header-submenu nav > ul > li {
  border-width:1px;
}

.header-submenu nav > ul > li {
  border-top-width:0px;
}

.header-submenu nav > ul > li {
  border-left-width:0px;
}

.header-submenu nav > ul > li {
  border-right-width:0px;
}

.header-submenu nav > ul > li {
  border-style:solid;
}

.header-submenu nav > ul > li {
  border-color:var(--neutral-gray-4);
}

.header-submenu nav > ul > li {
  padding-top:0.875rem;
  padding-bottom:0.875rem;
}

@media (min-width: 1024px) {
  .header-submenu nav > ul > li {
    margin-right:1rem;
  }
}

@media (min-width: 1024px) {
  .header-submenu nav > ul > li {
    border-style:none;
  }
}

@media (min-width: 1024px) {
  .header-submenu nav > ul > li {
    padding-bottom:0.625rem;
  }
}

@media (min-width: 1024px) {
  .header-submenu nav > ul > li {
    padding-top:0.75rem;
  }
}

@media (min-width: 1024px) {
  .header-submenu nav > ul > li {
    text-align:center;
  }
}

.header-submenu nav > ul > li > ul {
  margin-top:0.375rem;
}

@media (min-width: 1024px) {
  .header-submenu nav > ul > li > ul {
    z-index:50;
  }
}

.header-submenu nav > ul > li > ul > li {
  padding-top:0.375rem;
  padding-bottom:0.375rem;
}

.header-submenu nav > ul > li > ul > li {
  padding-left:0.5rem;
}

@media (min-width: 1024px) {
  .header-submenu nav > ul > li > ul > li {
    padding-left:1rem;
    padding-right:1rem;
  }
}

@media (min-width: 1024px) {
  .header-submenu nav > ul > li > ul > li {
    padding-top:1rem;
  }
}

@media (min-width: 1024px) {
  .header-submenu nav > ul > li > ul > li {
    padding-bottom:0px;
  }
}

@media (min-width: 1024px) {
  .header-submenu nav > ul > li > ul > li {
    text-align:left;
  }
}

.header-submenu nav > ul > li > ul {
  display:none;
}

.header-submenu nav > ul > li > ul {
  text-transform:none;
}

.header-submenu nav > ul > li:hover > ul, .header-submenu nav > ul > li:active > ul {
  display:block;
}

@media (min-width: 1024px) {
  .header-submenu nav > ul > li:hover > ul, .header-submenu nav > ul > li:active > ul {
    position:absolute;
  }
}

@media (min-width: 1024px) {
  .header-submenu nav > ul > li:hover > ul, .header-submenu nav > ul > li:active > ul {
    padding-top:1.5rem;
  }
}

@media (min-width: 1024px) {
  .header-submenu nav > ul > li:hover > ul > li, .header-submenu nav > ul > li:active > ul > li {
    background-color:var(--neutral-white);
  }
}

@media (min-width: 1024px) {
  .header-submenu nav > ul > li:hover > ul > li:first-child, .header-submenu nav > ul > li:active > ul > li:first-child {
    border-width:1px;
  }
}

@media (min-width: 1024px) {
  .header-submenu nav > ul > li:hover > ul > li:first-child, .header-submenu nav > ul > li:active > ul > li:first-child {
    border-bottom-width:0px;
  }
}

@media (min-width: 1024px) {
  .header-submenu nav > ul > li:hover > ul > li:first-child, .header-submenu nav > ul > li:active > ul > li:first-child {
    border-left-width:0px;
  }
}

@media (min-width: 1024px) {
  .header-submenu nav > ul > li:hover > ul > li:first-child, .header-submenu nav > ul > li:active > ul > li:first-child {
    border-right-width:0px;
  }
}

@media (min-width: 1024px) {
  .header-submenu nav > ul > li:hover > ul > li:first-child, .header-submenu nav > ul > li:active > ul > li:first-child {
    border-top-width:4px;
  }
}

@media (min-width: 1024px) {
  .header-submenu nav > ul > li:hover > ul > li:first-child, .header-submenu nav > ul > li:active > ul > li:first-child {
    border-style:solid;
  }
}

@media (min-width: 1024px) {
  .header-submenu nav > ul > li:hover > ul > li:first-child, .header-submenu nav > ul > li:active > ul > li:first-child {
    border-color:var(--primary-green);
  }
}

@media (min-width: 1024px) {
  .header-submenu nav > ul > li:hover > ul > li:last-child, .header-submenu nav > ul > li:active > ul > li:last-child {
    border-bottom-right-radius:0.75rem;
    border-bottom-left-radius:0.75rem;
  }
}

@media (min-width: 1024px) {
  .header-submenu nav > ul > li:hover > ul > li:last-child, .header-submenu nav > ul > li:active > ul > li:last-child {
    padding-bottom:1rem;
  }
}

.header-submenu a,
  .header-submenu ul,
  .header-submenu li{
    color:inherit;
    text-decoration:inherit;
    list-style-type:none;
    margin-left:0;
    padding-left:0;
    margin-block-start:0;
    margin-block-end:0;
    margin-inline-start:0;
    margin-inline-end:0;
    padding-inline-start:0;
  }

.header-submenu a:hover {
  color:var(--primary-blue-light-2);
}

a,
ul,
li{
  color:inherit;
  text-decoration:inherit;
  list-style-type:none;
  margin-left:0;
  padding-left:0;
  margin-block-start:0;
  margin-block-end:0;
  margin-inline-start:0;
  margin-inline-end:0;
  padding-inline-start:0;
}

:host {
  display:block;
}

[cloned-slot-name='subnav-label'] {
  display:none;
}

.has-navigation{
  --navigation-height:69px;
}

.has-navigation--start nav::before, .has-navigation--last nav::after {
  display:none !important;
}

@media (min-width: 1024px) {
  .has-navigation nav {
    position:relative;
  }
}

@media (min-width: 1024px) {
  .has-navigation nav {
    width:100%;
  }
}

@media (min-width: 1024px) {
  .has-navigation nav {
    max-width:56rem;
  }
}

@media (min-width: 1024px) {
  .has-navigation nav {
    overflow-x:clip;
  }
}

@media (min-width: 1280px) {
  .has-navigation nav {
    max-width:72rem;
  }
}

@media (min-width: 1360px) {
  .has-navigation nav {
    max-width:1280px;
  }
}

@media (min-width: 1024px) {
  .has-navigation nav::after, .has-navigation nav::before {
    position:absolute;
  }
}

@media (min-width: 1024px) {
  .has-navigation nav::after, .has-navigation nav::before {
    top:0px;
  }
}

@media (min-width: 1024px) {
  .has-navigation nav::after, .has-navigation nav::before {
    z-index:10;
  }
}

@media (min-width: 1024px) {
  .has-navigation nav::after, .has-navigation nav::before {
    display:block;
  }
}

@media (min-width: 1024px) {
  .has-navigation nav::after, .has-navigation nav::before {
    width:3rem;
  }
}

@media (min-width: 1024px) {
  .has-navigation nav::after, .has-navigation nav::before {
    --tw-gradient-from:var(--neutral-transparent);
    --tw-gradient-stops:var(--tw-gradient-from), var(--tw-gradient-to, rgb(255 255 255 / 0));
  }
}

@media (min-width: 1024px) {
  .has-navigation nav::after, .has-navigation nav::before {
    --tw-gradient-to:var(--primary-blue-light-2);
  }
}

@media (min-width: 1024px){

.has-navigation nav::after,
    .has-navigation nav::before{
        content:'';
        height:var(--navigation-height)
    }
      }

@media (min-width: 1024px) {
  .has-navigation nav::after {
    right:0px;
  }
}

@media (min-width: 1024px) {
  .has-navigation nav::after {
    background-image:linear-gradient(to right, var(--tw-gradient-stops));
  }
}

@media (min-width: 1024px) {
  .has-navigation nav::before {
    left:0px;
  }
}

@media (min-width: 1024px) {
  .has-navigation nav::before {
    background-image:linear-gradient(to left, var(--tw-gradient-stops));
  }
}

@media (min-width: 1024px) {
  .has-navigation nav > ul {
    width:max-content;
  }
}

@media (min-width: 1024px) {
  .has-navigation nav > ul {
    transition-property:transform;
    transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration:150ms;
  }
}

@media (min-width: 1024px) {
  .has-navigation nav > ul {
    transition-delay:75ms;
  }
}

.has-navigation .button {
  display:none;
}

@media (min-width: 1024px) {
  .has-navigation .button {
    display:inline-flex;
  }
}

@media (min-width: 1024px) {
  .has-navigation .button {
    cursor:pointer;
  }
}

@media (min-width: 1024px) {
  .has-navigation .button {
    align-items:center;
  }
}

@media (min-width: 1024px) {
  .has-navigation .button {
    justify-content:center;
  }
}

@media (min-width: 1024px) {
  .has-navigation .button {
    gap:0.5rem;
  }
}

@media (min-width: 1024px) {
  .has-navigation .button {
    border-width:0px;
  }
}

@media (min-width: 1024px) {
  .has-navigation .button {
    border-bottom-width:4px;
  }
}

@media (min-width: 1024px) {
  .has-navigation .button {
    border-color:var(--neutral-transparent);
  }
}

@media (min-width: 1024px) {
  .has-navigation .button {
    background-color:var(--primary-blue-light-2);
  }
}

@media (min-width: 1024px) {
  .has-navigation .button {
    padding-left:1rem;
    padding-right:1rem;
  }
}

@media (min-width: 1024px) {
  .has-navigation .button {
    font-size:var(--fs-sm);
    line-height:var(--lh-sm);
  }
}

@media (min-width: 1024px) {
  .has-navigation .button {
    font-weight:var(--fw-semibold);
  }
}

@media (min-width: 1024px) {
  .has-navigation .button {
    color:var(--neutral-white);
  }
}

@media (min-width: 1024px){

.has-navigation .button{
      height:var(--navigation-height)
  }
    }

@media (min-width: 1024px) {
  .has-navigation .button[disabled] {
    opacity:0.1;
  }
}

@media (min-width: 1024px) {
  .has-navigation .button[disabled] {
    transition-property:opacity;
    transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration:150ms;
  }
}

@media (min-width: 1024px) {
  .has-navigation [cloned-slot-name='navigation'] {
    margin-left:auto;
    margin-right:auto;
  }
}

@media (min-width: 1024px) {
  .has-navigation [cloned-slot-name='navigation'] {
    display:flex;
  }
}

@media (min-width: 1024px) {
  .navigation {
    display:flex;
  }
  .navigation {
    flex-direction:column;
  }
  .navigation {
    justify-content:center;
  }
}

.navigation nav > ul {
  position:relative;
}

.navigation nav > ul {
  display:block;
}

.navigation nav > ul {
  text-align:left;
}

.navigation nav > ul {
  font-weight:var(--fw-semibold);
}

@media (min-width: 1024px) {
  .navigation nav > ul {
    display:flex;
  }
}

@media (min-width: 1024px) {
  .navigation nav > ul {
    justify-content:space-between;
  }
}

@media (min-width: 1024px) {
  .navigation nav > ul {
    gap:1.5rem;
  }
}

@media (min-width: 1024px) {
  .navigation nav > ul {
    text-align:center;
  }
}

@media (min-width: 1024px) {
  .navigation nav > ul {
    font-size:var(--fs-sm);
    line-height:var(--lh-sm);
  }
}

@media (min-width: 1280px) {
  .navigation nav > ul {
    justify-content:center;
  }
}

.navigation nav > ul{
    line-height:1.2;
  }

.navigation nav > ul > li {
  border-width:0px;
}

.navigation nav > ul > li {
  border-bottom-width:1px;
}

.navigation nav > ul > li {
  border-style:solid;
}

.navigation nav > ul > li:last-child {
  border-style:none;
}

.navigation nav > ul > li.has-children {
  display:flex;
}

.navigation nav > ul > li.has-children {
  flex-wrap:wrap;
}

.navigation nav > ul > li.has-children {
  justify-content:space-between;
}

.btn.parent-container-fit.navigation nav > ul > li.has-children{
  justify-content:space-between;
}

@media (min-width: 1024px) {
  .navigation nav > ul > li.has-children {
    flex-wrap:nowrap;
  }
}

.navigation nav > ul > li > a, .navigation nav > ul > li > ghs-phone-contact {
  box-sizing:border-box;
}

.navigation nav > ul > li > a, .navigation nav > ul > li > ghs-phone-contact {
  display:flex;
}

.navigation nav > ul > li > a, .navigation nav > ul > li > ghs-phone-contact {
  height:100%;
}

.navigation nav > ul > li > a, .navigation nav > ul > li > ghs-phone-contact {
  align-items:center;
}

.navigation nav > ul > li[is-dropdown-open] ghs-icon{
    transform:rotate(180deg);
  }

.navigation nav > ul > li[is-dropdown-open] > ul {
  display:block;
}

@media (min-width: 1024px){
    .navigation nav > ul > li:hover > ul, .navigation nav > ul > li:active > ul {
    display:block;
  }
  }

.navigation nav > ul > li > ul {
  display:none;
}

.navigation nav > ul > li > ul {
  width:100%;
}

@media (min-width: 1024px) {
  .navigation nav > ul > li > ul {
    position:absolute;
  }
}

@media (min-width: 1024px) {
  .navigation nav > ul > li > ul {
    z-index:50;
  }
}

@media (min-width: 1024px) {
  .navigation nav > ul > li > ul {
    margin-top:0px;
  }
}

@media (min-width: 1024px) {
  .navigation nav > ul > li > ul {
    width:auto;
  }
}

@media (min-width: 1024px) {
  .navigation nav > ul > li > ul {
    background-color:var(--neutral-white);
  }
}

.navigation nav > ul > li > ul > li {
  padding-left:0.5rem;
}

@media (min-width: 1024px) {
  .navigation nav > ul > li > ul > li {
    padding-left:1.25rem;
    padding-right:1.25rem;
  }
}

@media (min-width: 1024px) {
  .navigation nav > ul > li > ul > li {
    padding-top:0px;
  }
}

@media (min-width: 1024px) {
  .navigation nav > ul > li > ul > li {
    padding-bottom:0px;
  }
}

@media (min-width: 1024px) {
  .navigation nav > ul > li > ul > li {
    text-align:left;
  }
}

.navigation nav > ul > li > ul > li:first-child {
  display:block;
}

.navigation nav > ul > li > ul > li:last-child {
  padding-bottom:0.5rem;
}

@media (min-width: 1024px) {
  .navigation nav > ul > li > ul > li:last-child {
    padding-bottom:1.25rem;
  }
}

.navigation button.dropdown-trigger {
  position:relative;
}

.navigation button.dropdown-trigger {
  display:inline-flex;
}

.navigation button.dropdown-trigger {
  min-height:44px;
}

.navigation button.dropdown-trigger {
  min-width:22px;
}

.navigation button.dropdown-trigger {
  cursor:pointer;
}

.navigation button.dropdown-trigger {
  align-items:center;
}

.navigation button.dropdown-trigger {
  justify-content:flex-end;
}

.navigation button.dropdown-trigger {
  border-width:0px;
}

.navigation button.dropdown-trigger {
  background-color:var(--neutral-transparent);
}

.navigation button.dropdown-trigger {
  padding-left:0px;
  padding-right:0px;
}

.navigation button.dropdown-trigger {
  text-align:left;
}

.navigation button.dropdown-trigger {
  font-size:var(--fs-base);
  line-height:var(--lh-base);
}

.navigation button.dropdown-trigger {
  font-weight:var(--fw-semibold);
}

@media (min-width: 1024px) {
  .navigation button.dropdown-trigger {
    justify-content:flex-start;
  }
}

@media (min-width: 1024px) {
  .navigation button.dropdown-trigger {
    text-align:center;
  }
}

@media (min-width: 1024px) {
  .navigation button.dropdown-trigger {
    font-size:var(--fs-sm);
    line-height:var(--lh-sm);
  }
}

.navigation button.dropdown-trigger ghs-icon {
  display:flex;
}

.navigation button.dropdown-trigger ghs-icon {
  height:1.25rem;
}

.navigation button.dropdown-trigger ghs-icon {
  width:1.25rem;
}

.navigation button.dropdown-trigger ghs-icon {
  align-items:center;
}

.navigation button.dropdown-trigger ghs-icon {
  justify-content:center;
}

@media (min-width: 1024px) {
  .navigation button.dropdown-trigger ghs-icon {
    margin-left:0.5rem;
  }
}

@media (min-width: 1024px) {
  .navigation button.dropdown-trigger ghs-icon {
    height:1rem;
  }
}

@media (min-width: 1024px) {
  .navigation button.dropdown-trigger ghs-icon {
    width:0.75rem;
  }
}

.navigation.secondary-menu a {
  pointer-events:auto;
}

.navigation.secondary-menu a {
  cursor:pointer;
}

.navigation.secondary-menu a {
  padding-left:0.5rem;
  padding-right:0.5rem;
}

.navigation.secondary-menu a {
  text-transform:capitalize;
}

.navigation.secondary-menu a.is-active:after {
  pointer-events:auto;
}

.navigation.secondary-menu a.is-active:after {
  cursor:pointer;
}

.secondary-menu nav > ul, :host([is-subnav]) nav > ul {
  gap:1.5rem;
}

:host([is-subnav]) .navigation {
  background-color:var(--neutral-white);
}

@media (min-width: 1024px){

:host([is-subnav]) .navigation{
      box-shadow:var(--brand-shadow)
  }
    }

@media (min-width: 1024px) {
  :host([is-subnav]) nav > ul {
    justify-content:center;
  }
}

:host([is-subnav]) nav > ul > li {
  flex-shrink:0;
}

:host([is-subnav]) nav > ul > li{
    text-transform:none;
  }

@media (min-width: 1024px) {
  :host([is-subnav]) nav > ul > li > ul {
    padding-top:0px;
  }
}

:host([is-top-bar-menu]) .navigation nav > ul {
  font-weight:var(--fw-normal);
}

:host([is-top-bar-menu]) .navigation nav > ul {
  display:flex;
}

:host([is-top-bar-menu]) .navigation nav > ul {
  flex-direction:column;
}

:host([is-top-bar-menu]) .navigation nav > ul {
  gap:0.5rem;
}

:host([is-top-bar-menu]) .navigation nav > ul {
  font-family:var(--ff-body);
}

@media (min-width: 1024px) {
  :host([is-top-bar-menu]) .navigation nav > ul {
    flex-direction:row;
  }
}

@media (min-width: 1024px) {
  :host([is-top-bar-menu]) .navigation nav > ul {
    justify-content:flex-end;
  }
}

@media (min-width: 1024px) {
  :host([is-top-bar-menu]) .navigation nav > ul {
    gap:1.75rem;
  }
}

:host([is-top-bar-menu]) .navigation nav > ul > li {
  min-width:22px;
}

:host([is-top-bar-menu]) .navigation nav > ul > li {
  align-items:center;
}

:host([is-top-bar-menu]) .navigation nav > ul > li {
  display:none;
}

:host([is-top-bar-menu]) .navigation nav > ul > li {
  border-style:none;
}

:host([is-top-bar-menu]) .navigation nav > ul > li:not(.tel) {
  display:none;
}

@media (min-width: 1024px) {
  :host([is-top-bar-menu]) .navigation nav > ul > li:not(.tel) {
    display:flex;
  }
}

:host([is-top-bar-menu]) .navigation nav > ul > li > a:after {
  display:none;
}

:host([is-top-bar-menu]) .navigation nav > ul > li > a, :host([is-top-bar-menu]) .navigation nav > ul > li > ghs-phone-contact {
  min-height:3.5rem;
}

:host([is-top-bar-menu]) .navigation nav > ul > li > a, :host([is-top-bar-menu]) .navigation nav > ul > li > ghs-phone-contact {
  padding-top:0px;
  padding-bottom:0px;
}

@media (min-width: 1024px) {
  :host([is-top-bar-menu]) .navigation nav > ul > li > a, :host([is-top-bar-menu]) .navigation nav > ul > li > ghs-phone-contact {
    min-height:fit-content;
  }
}

@media (min-width: 320px){
    :host([is-top-bar-menu]) nav > ul > li {
    display:block;
  }

    :host([is-top-bar-menu]) button.dropdown-trigger {
    font-weight:var(--fw-normal);
  }
      @media (min-width: 1024px) {
    :host([is-top-bar-menu]) button.dropdown-trigger.no-link {
      padding-top:0px;
      padding-bottom:0px;
    }
  }
  }

@media (min-width: 1024px) {
  :host([site='GHS']) nav .button {
    color:var(--primary-blue);
  }
}

:host([site='GHS']) .navigation nav > ul {
  font-family:var(--ff-body);
}

:host([site='GHS']) .navigation nav > ul {
  color:var(--primary-blue-dark);
}

:host([site='GHS']) .navigation nav > ul > li {
  border-color:var(--neutral-gray-4);
}

:host([site='GHS']) .navigation nav > ul > li {
  text-transform:uppercase;
}

@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li {
    border-bottom-width:4px;
  }
}

@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li {
    border-style:solid;
  }
}

@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li {
    border-color:var(--outline-transparent);
  }
}

:host([site='GHS']) .navigation nav > ul > li.tel {
  display:none;
}

@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li.tel {
    display:block;
  }
}

:host([site='GHS']) .navigation nav > ul > li.is-active, :host([site='GHS']) .navigation nav > ul > li:has(a.is-active) {
  margin-left:-1.5rem;
  margin-right:-1.5rem;
}

:host([site='GHS']) .navigation nav > ul > li.is-active, :host([site='GHS']) .navigation nav > ul > li:has(a.is-active) {
  border-top-width:1px;
}

:host([site='GHS']) .navigation nav > ul > li.is-active, :host([site='GHS']) .navigation nav > ul > li:has(a.is-active) {
  padding-left:1.5rem;
  padding-right:1.5rem;
}

@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li.is-active, :host([site='GHS']) .navigation nav > ul > li:has(a.is-active) {
    margin:0px;
  }
}

@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li.is-active, :host([site='GHS']) .navigation nav > ul > li:has(a.is-active) {
    border-top-width:0px;
  }
}

@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li.is-active, :host([site='GHS']) .navigation nav > ul > li:has(a.is-active) {
    padding-left:0px;
    padding-right:0px;
  }
}

:host([site='GHS']) .navigation nav > ul > li:has(+ li.is-active), :host([site='GHS']) .navigation nav > ul > li:has(+ li a.is-active) {
  border-bottom-width:0px;
}

@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li:has(+ li.is-active), :host([site='GHS']) .navigation nav > ul > li:has(+ li a.is-active) {
    border-bottom-width:4px;
  }
}

:host([site='GHS']) .navigation nav > ul > li > a, :host([site='GHS']) .navigation nav > ul > li > ghs-phone-contact {
  min-height:5rem;
}

:host([site='GHS']) .navigation nav > ul > li > a, :host([site='GHS']) .navigation nav > ul > li > ghs-phone-contact {
  padding-top:1.5rem;
  padding-bottom:1.5rem;
}

@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li > a, :host([site='GHS']) .navigation nav > ul > li > ghs-phone-contact {
    min-height:0px;
  }
}

:host([site='GHS']) .navigation nav > ul > li:has(a.is-active) > a {
  margin-left:-1.5rem;
}

:host([site='GHS']) .navigation nav > ul > li:has(a.is-active) > a {
  padding-left:1rem;
}

:host([site='GHS']) .navigation nav > ul > li:has(a.is-active) > a{
      border-left:0.5rem solid var(--primary-green);
    }

@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li:has(a.is-active) > a {
    margin-left:0px;
    margin-right:0px;
  }
}

@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li:has(a.is-active) > a {
    border-left-width:0px;
  }
}

@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li:has(a.is-active) > a {
    padding-left:0px;
    padding-right:0px;
  }
}

@media (min-width: 1024px){

:host([site='GHS']) .navigation{
  }
      :host([site='GHS']) .navigation nav > ul > li > a{
        transition:all 0.2s ease-in-out;
        position:relative;
      }

        :host([site='GHS']) .navigation nav > ul > li > a:after{
          content:'';
          position:absolute;
          bottom:-5px;
          left:0;
          width:0px;
          height:4px;
          margin:5px 0 0;
          transition:all 0.2s ease-in-out;
          transition-duration:0.25s;
          opacity:0;
        }
        :host([site='GHS']) .navigation nav > ul > li:not(.has-children):hover > a:after, :host([site='GHS']) .navigation nav > ul > li:has(a.is-active) > a:after, :host([site='GHS']) .navigation nav > ul > li > a.is-active:after{
          width:100%;
          opacity:1;
        }
        :host([site='GHS']) .navigation nav > ul > li.has-children > a.is-active:after, :host([site='GHS']) .navigation nav > ul > li.has-children:has(a.is-active) > a:after{
          width:calc(100% + 20px);
        }
    }

:host([site='GHS']) .navigation nav > ul > li > a {
  font-family:var(--ff-display);
}

@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li > a:after {
    background-color:var(--primary-green);
  }
}

:host([site='GHS']) .navigation nav > ul > li > ul {
  visibility:hidden;
}

:host([site='GHS']) .navigation nav > ul > li > ul {
  text-transform:none;
}

@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li > ul {
    display:block;
  }
}

@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li > ul {
    border-bottom-right-radius:0.75rem;
  }
}

@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li > ul {
    border-bottom-left-radius:0.75rem;
  }
}

@media (min-width: 1024px){

:host([site='GHS']) .navigation nav > ul > li > ul{
        box-shadow:var(--brand-shadow);
        top:calc(100% - 3px)
    }

        @media (min-width: 1024px) {
    :host([site='GHS']) .navigation nav > ul > li > ul:before {
      background-color:var(--primary-green);
    }
  }

        :host([site='GHS']) .navigation nav > ul > li > ul:before{

          content:'';
          transition:all 0.2s ease-in-out;
          transition-duration:0.25s;
          opacity:0;
          width:0;
          height:4px;
          display:block;
        }
      }

:host([site='GHS']) .navigation nav > ul > li[is-dropdown-open] > ul {
  visibility:visible;
}

:host([site='GHS']) .navigation nav > ul > li[is-dropdown-open] > ul {
  display:block;
}

:host([site='GHS']) .navigation nav > ul > li[is-dropdown-open] > ul:before{
        width:100%;
        opacity:1;
      }

@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li > ul > li:first-child {
    padding-top:1.25rem;
  }
}

:host([site='GHS']) .navigation nav > ul > li > ul > li > a {
  display:block;
}

:host([site='GHS']) .navigation nav > ul > li > ul > li > a {
  padding-top:1rem;
  padding-bottom:1rem;
}

:host([site='GHS']) .navigation nav > ul > li > ul > li > a {
  font-weight:var(--fw-semibold);
}

:host([site='GHS']) .navigation nav > ul > li > ul > li > a {
  color:var(--primary-blue-dark);
}

@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li > ul > li > a {
    padding-top:0.5rem;
    padding-bottom:0.5rem;
  }
}

:host([site='GHS']) .navigation nav > ul > li > ul > li > a.is-active {
  padding-left:0.5rem;
}

:host([site='GHS']) .navigation nav > ul > li > ul > li > a.is-active {
  color:var(--primary-blue-light-2);
}

:host([site='GHS']) .navigation nav > ul > li > ul > li > a.is-active{
        border-left:0.5rem solid var(--primary-green);
      }

@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li > ul > li > a.is-active {
    margin-left:-1rem;
  }
}

@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li > ul > li > a.is-active {
    padding-top:0.5rem;
    padding-bottom:0.5rem;
  }
}

@media (min-width: 1024px) {
  :host([site='GHS']) .navigation nav > ul > li > ul > li > a:hover, :host([site='GHS']) .navigation nav > ul > li > ul > li > a.is-active {
    text-decoration-line:underline;
  }
}

:host([site='GHS']) .navigation button.dropdown-trigger {
  font-family:var(--ff-display);
}

:host([site='GHS']) .navigation button.dropdown-trigger {
  text-transform:uppercase;
}

:host([site='GHS']) .navigation button.dropdown-trigger {
  color:var(--primary-blue-dark);
}

:host([site='GHS']) .navigation button.dropdown-trigger:hover, :host([site='GHS']) .navigation a:hover, :host([site='GHS']) .navigation a.is-active {
  color:var(--primary-blue-light-2);
}

:host([site='GHS']) .navigation button.dropdown-trigger:hover ghs-icon, :host([site='GHS']) .navigation a:hover ghs-icon, :host([site='GHS']) .navigation a.is-active ghs-icon {
  color:var(--primary-blue-light-2);
}

:host([site='GHS']) .navigation button.dropdown-trigger.no-link {
  display:flex;
}

:host([site='GHS']) .navigation button.dropdown-trigger.no-link {
  height:100%;
}

:host([site='GHS']) .navigation button.dropdown-trigger.no-link {
  width:100%;
}

:host([site='GHS']) .navigation button.dropdown-trigger.no-link {
  align-items:center;
}

:host([site='GHS']) .navigation button.dropdown-trigger.no-link {
  justify-content:space-between;
}

:host([site='GHS']) .navigation button.dropdown-trigger.no-link {
  padding-top:1.5rem;
  padding-bottom:1.5rem;
}

:host([site='GHS']) .navigation .btn.parent-container-fitbutton.dropdown-trigger.no-link{
  justify-content:space-between;
}

@media (min-width: 1024px) {
  :host([site='GHS']) .navigation button.dropdown-trigger.no-link {
    justify-content:flex-start;
  }
}

@media (min-width: 1024px) {
  :host([site='GHS']) .navigation button.dropdown-trigger.no-link {
    padding-top:0px;
    padding-bottom:0px;
  }
}

:host([site='GHS']) .navigation.secondary-menu {
  background-color:var(--primary-blue-dark);
}

:host([site='GHS']) .navigation.secondary-menu a {
  color:var(--neutral-white);
}

:host([site='GHS']) .navigation.secondary-menu a:hover:after {
  background-color:var(--neutral-white);
}

:host([site='GHS']) .navigation.secondary-menu a.is-active:after {
  background-color:var(--primary-blue-light-3);
}

:host([site='GHS']):host([is-top-bar-menu]) .navigation nav > ul > li.tel {
  display:block;
}

:host([site='GHS']):host([is-top-bar-menu]) .navigation nav > ul > li.tel ghs-phone-contact {
  min-height:3.5rem;
}

:host([site='GHS']):host([is-top-bar-menu]) .navigation nav > ul > li.tel ghs-phone-contact {
  padding-top:0px;
  padding-bottom:0px;
}

:host([site='GHS']):host([is-utility-menu]) .navigation nav > ul {
  font-family:var(--ff-body);
}

@media (min-width: 1024px) {
  :host([site='GHS']):host([is-utility-menu]) .navigation nav > ul {
    display:flex;
  }
}

@media (min-width: 1024px) {
  :host([site='GHS']):host([is-utility-menu]) .navigation nav > ul {
    flex-direction:row;
  }
}

@media (min-width: 1024px) {
  :host([site='GHS']):host([is-utility-menu]) .navigation nav > ul {
    justify-content:flex-end;
  }
}

@media (min-width: 1024px) {
  :host([site='GHS']):host([is-utility-menu]) .navigation nav > ul {
    gap:1.75rem;
  }
}

:host([site='GHS']):host([is-utility-menu]) .navigation nav > ul > li {
  border-top-width:1px;
}

:host([site='GHS']):host([is-utility-menu]) .navigation nav > ul > li {
  border-bottom-width:0px;
}

:host([site='GHS']):host([is-utility-menu]) .navigation nav > ul > li {
  border-style:solid;
}

:host([site='GHS']):host([is-utility-menu]) .navigation nav > ul > li {
  border-color:var(--neutral-gray-4);
}

@media (min-width: 1024px) {
  :host([site='GHS']):host([is-utility-menu]) .navigation nav > ul > li {
    border-top-width:0px;
  }
}

@media (min-width: 1024px) {
  :host([site='GHS']):host([is-utility-menu]) .navigation nav > ul > li > a, :host([site='GHS']):host([is-utility-menu]) .navigation nav > ul > li > ghs-phone-contact {
    min-height:3.5rem;
  }
}

@media (min-width: 1024px) {
  :host([site='GHS']):host([is-utility-menu]) .navigation nav > ul > li > a, :host([site='GHS']):host([is-utility-menu]) .navigation nav > ul > li > ghs-phone-contact {
    min-height:fit-content;
  }
}

@media (min-width: 1024px) {
  :host([site='GHS']):host([is-utility-menu]) .navigation nav > ul > li > a, :host([site='GHS']):host([is-utility-menu]) .navigation nav > ul > li > ghs-phone-contact {
    padding-top:0px;
    padding-bottom:0px;
  }
}

:host([site='GHS']):host([is-subnav]) nav > ul > li {
  text-transform:none;
}

@media (min-width: 1024px) {
  :host([site='GHS']):host([is-subnav]) nav > ul > li > a:after {
    background-color:var(--primary-blue-light-3);
  }
}

:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant {
  background-color:var(--primary-blue-light-2);
}

:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant {
  color:var(--neutral-white);
}

:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant [cloned-slot-name='subnav-label'] {
  display:block;
}

@media (min-width: 1024px) {
  :host([site='GHS']):host([is-subnav]) .navigation.subnav-variant [cloned-slot-name='subnav-label'] {
    display:none;
  }
}

:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant [cloned-slot-name='subnav-label'] button.dropdown-trigger.open ghs-icon{
            transform:rotate(180deg);
          }

:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav {
  margin-left:auto;
}

:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav {
  margin-right:auto;
}

:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav {
  display:none;
}

@media (min-width: 1024px) {
  :host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav {
    display:block;
  }
}

@media (min-width: 1024px) {
  :host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav {
    max-width:1024px;
  }
}

@media (min-width: 1280px) {
  :host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav {
    max-width:1280px;
  }
}

@media (min-width: 1360px) {
  :host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav {
    max-width:1360px;
  }
}

@media (min-width: 2180px) {
  :host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav {
    max-width:1360px;
  }
}

:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav.hide {
  display:block;
}

:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant > div > button.dropdown-trigger {
  width:100%;
}

:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant > div > button.dropdown-trigger {
  justify-content:space-between;
}

:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant > div > button.dropdown-trigger {
  padding-top:1.5rem;
  padding-bottom:1.5rem;
}

:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant > div > button.dropdown-trigger {
  padding-left:1rem;
  padding-right:1rem;
}

:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant > div > button.dropdown-trigger {
  color:var(--neutral-white);
}

.btn.parent-container-fit:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant > div > button.dropdown-trigger{
  justify-content:space-between;
}

@media (min-width: 1024px) {
  :host([site='GHS']):host([is-subnav]) .navigation.subnav-variant > div > button.dropdown-trigger {
    display:none;
  }
}

:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant > div > button.dropdown-trigger {
  border-width:0px;
}

:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant > div > button.dropdown-trigger {
  border-bottom-width:1px;
}

:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant > div > button.dropdown-trigger {
  border-style:solid;
}

:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant > div > button.dropdown-trigger {
  border-color:var(--neutral-white);
}

:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant > div > button.dropdown-trigger ghs-icon {
  border-color:var(--neutral-white);
}

:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant > div > button.dropdown-trigger ghs-icon {
  color:var(--neutral-white);
}

:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant > div > button.dropdown-trigger:hover {
  cursor:pointer;
}

@media (min-width: 1024px) {
  :host([site='GHS']):host([is-subnav]) .navigation.subnav-variant > div > button.dropdown-trigger:hover {
    background-color:var(--neutral-white);
  }
}

:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul {
  justify-content:flex-start;
}

:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul {
  gap:0.5rem;
}

:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul > li button.dropdown-trigger {
  padding-left:1rem;
  padding-right:1rem;
}

:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul > li button.dropdown-trigger {
  color:var(--neutral-white);
}

@media (min-width: 1024px) {
  :host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul > li button.dropdown-trigger:hover {
    color:var(--primary-blue-dark);
  }
}

:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul > li a + button.dropdown-trigger {
  margin-left:-1rem;
}

:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul > li a + button.dropdown-trigger {
  padding-left:0px;
}

:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul > li:hover {
  cursor:pointer;
}

@media (min-width: 1024px) {
  :host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul > li:hover {
    background-color:var(--neutral-white);
  }
}

@media (min-width: 1024px) {
  :host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul > li:hover a {
    color:var(--primary-blue-dark);
  }
}

@media (min-width: 1024px) {
  :host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul > li:hover ghs-icon {
    color:var(--primary-blue-dark);
  }
}

:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul > li a {
  padding-left:1rem;
  padding-right:1rem;
}

:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul > li a {
  color:var(--neutral-white);
}

@media (min-width: 1024px) {
  :host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul > li a:after {
    background-color:var(--primary-blue);
  }
}

:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul > li ghs-icon {
  border-color:var(--neutral-white);
}

:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul > li ghs-icon {
  color:var(--neutral-white);
}

:host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul > li > ul li:first-child {
  border-color:var(--primary-blue);
}

@media (min-width: 1024px) {
  :host([site='GHS']):host([is-subnav]) .navigation.subnav-variant nav > ul > li > ul a {
    color:var(--primary-blue-dark);
  }
}

@media (min-width: 1024px) {
  :host([site='GHS']):host([is-subnav]) nav > ul > li > ul > li:first-child {
    border-color:var(--primary-blue-light-3);
  }
}

:host([site='GHS']):host([is-subnav]) button.dropdown-trigger {
  text-transform:none;
}

:host([site='BH']) nav .button, :host([site='BH']) nav button {
  font-family:var(--bh-ff-body);
}

@media (min-width: 1024px) {
  :host([site='BH']) nav .button, :host([site='BH']) nav button {
    color:var(--bh-neutral-default);
  }
}

:host([site='BH']) .navigation {
  background-color:var(--bh-neutral-white);
}

:host([site='BH']) .navigation {
  font-weight:var(--fw-bold);
}

@media (min-width: 1024px){

:host([site='BH']) .navigation{
      box-shadow:none
  }
    }

:host([site='BH']) .navigation nav > ul {
  font-family:var(--bh-ff-body);
}

:host([site='BH']) .navigation nav > ul {
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
}

:host([site='BH']) .navigation nav > ul {
  font-weight:var(--fw-bold);
}

:host([site='BH']) .navigation nav > ul {
  color:var(--bh-brand-primary-default);
}

@media (min-width: 1024px) {
  :host([site='BH']) .navigation nav > ul {
    gap:0px;
  }
}

@media (min-width: 1360px) {
  :host([site='BH']) .navigation nav > ul {
    gap:2rem;
  }
}

:host([site='BH']) .navigation nav > ul > li {
  display:flex;
}

:host([site='BH']) .navigation nav > ul > li {
  min-height:4rem;
}

:host([site='BH']) .navigation nav > ul > li {
  flex-direction:row;
}

:host([site='BH']) .navigation nav > ul > li {
  justify-content:space-between;
}

:host([site='BH']) .navigation nav > ul > li {
  border-color:var(--bh-neutral-default);
}

:host([site='BH']) .navigation nav > ul > li {
  padding-left:1rem;
  padding-right:1rem;
}

:host([site='BH']) .navigation .btn.parent-container-fitnav > ul > li{
  justify-content:space-between;
}

@media (min-width: 1024px) {
  :host([site='BH']) .navigation nav > ul > li {
    justify-content:flex-start;
  }
}

@media (min-width: 1024px) {
  :host([site='BH']) .navigation nav > ul > li {
    border-width:0px;
  }
}

@media (min-width: 1024px) {
  :host([site='BH']) .navigation nav > ul > li {
    border-top-width:4px;
    border-bottom-width:4px;
  }
}

@media (min-width: 1024px) {
  :host([site='BH']) .navigation nav > ul > li {
    border-style:solid;
  }
}

@media (min-width: 1024px) {
  :host([site='BH']) .navigation nav > ul > li {
    border-color:var(--outline-transparent);
  }
}

@media (min-width: 1024px) {
  :host([site='BH']) .navigation nav > ul > li {
    padding-left:0.625rem;
    padding-right:0.625rem;
  }
}

:host([site='BH']) .navigation nav > ul > li:hover, :host([site='BH']) .navigation nav > ul > li[is-dropdown-open] {
  background-color:var(--bh-brand-primary-lightest);
}

@media (min-width: 1024px) {
  :host([site='BH']) .navigation nav > ul > li:hover, :host([site='BH']) .navigation nav > ul > li[is-dropdown-open] {
    border-top-color:var(--bh-brand-primary-default);
  }
}

@media (min-width: 1024px) {
  :host([site='BH']) .navigation nav > ul > li:hover, :host([site='BH']) .navigation nav > ul > li[is-dropdown-open] {
    border-bottom-color:var(--bh-brand-primary-lightest);
  }
}

:host([site='BH']) .navigation nav > ul > li > a {
  min-height:4rem;
}

@media (min-width: 1024px) {
  :host([site='BH']) .navigation nav > ul > li > a {
    min-height:0px;
  }
}

:host([site='BH']) .navigation nav > ul > li > ul {
  background-color:var(--bh-brand-primary-lightest);
}

:host([site='BH']) .navigation nav > ul > li > ul {
  font-size:var(--fs-base);
  line-height:var(--lh-base);
}

:host([site='BH']) .navigation nav > ul > li > ul {
  color:var(--bh-brand-primary-default);
}

@media (min-width: 1024px) {
  :host([site='BH']) .navigation nav > ul > li > ul {
    margin-left:-0.625rem;
  }
}

@media (min-width: 1024px){

:host([site='BH']) .navigation nav > ul > li > ul{
        top:100%
    }
      }

:host([site='BH']) .navigation nav > ul > li > ul > li {
  padding-bottom:2rem;
}

@media (min-width: 1024px) {
  :host([site='BH']) .navigation nav > ul > li > ul > li {
    padding-bottom:1.25rem;
  }
}

@media (min-width: 1024px) {
  :host([site='BH']) .navigation nav > ul > li > ul > li:first-child {
    padding-top:1.25rem;
  }
}

:host([site='BH']) .navigation nav > ul > li > ul > li > a {
  display:block;
}

:host([site='BH']) .navigation nav > ul > li > ul > li > a {
  font-weight:var(--fw-normal);
}

:host([site='BH']) .navigation nav > ul > li > ul > li > a:hover, :host([site='BH']) .navigation nav > ul > li > ul > li > a.is-active {
  text-decoration-line:underline;
}

:host([site='BH']) .navigation button.dropdown-trigger {
  display:flex;
}

:host([site='BH']) .navigation button.dropdown-trigger {
  min-height:4rem;
}

:host([site='BH']) .navigation button.dropdown-trigger {
  justify-content:space-between;
}

:host([site='BH']) .navigation button.dropdown-trigger {
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
}

:host([site='BH']) .navigation button.dropdown-trigger {
  font-weight:var(--fw-bold);
}

:host([site='BH']) .navigation button.dropdown-trigger {
  color:var(--bh-brand-primary-default);
}

:host([site='BH']) .navigation .btn.parent-container-fitbutton.dropdown-trigger{
  justify-content:space-between;
}

@media (min-width: 1024px) {
  :host([site='BH']) .navigation button.dropdown-trigger {
    height:100%;
  }
}

@media (min-width: 1024px) {
  :host([site='BH']) .navigation button.dropdown-trigger {
    min-height:0px;
  }
}

@media (min-width: 1024px) {
  :host([site='BH']) .navigation button.dropdown-trigger {
    width:auto;
  }
}

@media (min-width: 1024px) {
  :host([site='BH']) .navigation button.dropdown-trigger {
    justify-content:flex-start;
  }
}

@media (min-width: 1024px) {
  :host([site='BH']) .navigation button.dropdown-trigger {
    padding-top:0px;
    padding-bottom:0px;
  }
}

:host([site='BH']) .navigation button.dropdown-trigger.no-link {
  width:100%;
}

@media (min-width: 1024px) {
  :host([site='BH']) .navigation button.dropdown-trigger.no-link {
    width:auto;
  }
}

:host([site='BH']) .navigation button.dropdown-trigger:hover, :host([site='BH']) .navigation a:hover, :host([site='BH']) .navigation a.is-active {
  color:var(--bh-brand-primary-dark);
}

:host([site='BH']) .navigation button.dropdown-trigger:hover ghs-icon, :host([site='BH']) .navigation a:hover ghs-icon, :host([site='BH']) .navigation a.is-active ghs-icon {
  color:var(--bh-neutral-darker);
}

:host([site='BH']) .navigation button.dropdown-trigger[aria-expanded='true'] {
  margin-bottom:1rem;
}

@media (min-width: 1024px) {
  :host([site='BH']) .navigation button.dropdown-trigger[aria-expanded='true'] {
    margin-bottom:0px;
  }
}

:host([site='BH']) .navigation.secondary-menu {
  background-color:var(--bh-brand-primary-darker);
}

:host([site='BH']) .navigation.secondary-menu a {
  color:var(--bh-neutral-white);
}

:host([site='BH']) .navigation.secondary-menu a:hover:before {
  background-color:var(--bh-neutral-white);
}

:host([site='BH']) .navigation.secondary-menu a.is-active:before {
  background-color:var(--bh-brand-primary-light);
}

:host([site='BH']):host([is-top-bar-menu]) .navigation {
  background-color:var(--neutral-transparent);
}

:host([site='BH']):host([is-top-bar-menu]) .navigation nav > ul > li {
  min-height:0px;
}

:host([site='BH']):host([is-top-bar-menu]) .navigation nav > ul > li {
  background-color:var(--neutral-transparent);
}

:host([site='BH']):host([is-top-bar-menu]) .navigation nav > ul > li {
  padding-left:0px;
  padding-right:0px;
}

:host([site='BH']):host([is-utility-menu]) .navigation {
  border-width:0px;
}

:host([site='BH']):host([is-utility-menu]) .navigation {
  border-top-width:1px;
}

:host([site='BH']):host([is-utility-menu]) .navigation {
  border-bottom-width:1px;
}

:host([site='BH']):host([is-utility-menu]) .navigation {
  border-style:solid;
}

:host([site='BH']):host([is-utility-menu]) .navigation {
  border-color:var(--bh-neutral-default);
}

:host([site='BH']):host([is-utility-menu]) .navigation {
  background-color:var(--bh-neutral-lighter);
}

@media (min-width: 1024px) {
  :host([site='BH']):host([is-utility-menu]) .navigation {
    border-style:none;
  }
}

@media (min-width: 1024px) {
  :host([site='BH']):host([is-utility-menu]) .navigation {
    background-color:var(--neutral-transparent);
  }
}

@media (min-width: 1024px) {
  :host([site='BH']):host([is-utility-menu]) .navigation {
    padding:0px;
  }
}

:host([site='BH']):host([is-utility-menu]) .navigation nav > ul {
  font-family:var(--bh-ff-body);
}

:host([site='BH']):host([is-utility-menu]) .navigation nav > ul {
  font-size:var(--fs-base);
  line-height:var(--lh-base);
}

@media (min-width: 1024px) {
  :host([site='BH']):host([is-utility-menu]) .navigation nav > ul {
    justify-content:space-between;
  }
}

@media (min-width: 1024px) {
  :host([site='BH']):host([is-utility-menu]) .navigation nav > ul {
    gap:1rem;
  }
}

:host([site='BH']):host([is-utility-menu]) .navigation nav > ul > li {
  align-items:flex-start;
}

@media (min-width: 1024px) {
  :host([site='BH']):host([is-utility-menu]) .navigation nav > ul > li {
    align-items:center;
  }
}

@media (min-width: 1024px) {
  :host([site='BH']):host([is-utility-menu]) .navigation nav > ul > li {
    border-width:0px;
  }
}

:host([site='BH']):host([is-utility-menu]) .navigation button.dropdown-trigger, :host([site='BH']):host([is-utility-menu]) .navigation nav > ul {
  font-size:var(--fs-base);
  line-height:var(--lh-base);
}

:host([site='BH']):host([is-utility-menu]) .navigation button.dropdown-trigger, :host([site='BH']):host([is-utility-menu]) .navigation nav > ul {
  font-weight:var(--fw-normal);
}

:host([site='BH']):host([is-utility-menu]) .navigation button.dropdown-trigger, :host([site='BH']):host([is-utility-menu]) .navigation nav > ul {
  color:var(--bh-neutral-black);
}

:host([site='BH']):host([is-utility-menu]) .navigation button.dropdown-trigger:hover, :host([site='BH']):host([is-utility-menu]) .navigation a:hover, :host([site='BH']):host([is-utility-menu]) .navigation a.is-active {
  color:var(--bh-brand-primary-dark);
}

:host([site='BH']):host([is-utility-menu]) button.dropdown-trigger:hover, :host([site='BH']):host([is-utility-menu]) a:hover, :host([site='BH']):host([is-utility-menu]) a.is-active {
  color:var(--bh-brand-primary-dark);
}

:host([site='BH']):host([is-utility-menu]) button.dropdown-trigger:hover ghs-icon, :host([site='BH']):host([is-utility-menu]) a:hover ghs-icon, :host([site='BH']):host([is-utility-menu]) a.is-active ghs-icon {
  color:var(--bh-neutral-darker);
}

:host([site='BH']):host([is-subnav]) nav > ul {
  z-index:50;
}

@media (min-width: 1024px) {
  :host([site='BH']):host([is-subnav]) nav > ul > li > a:after {
    background-color:var(--bh-brand-primary-light);
  }
}

@media (min-width: 1024px) {
  :host([site='BH']):host([is-subnav]) nav > ul > li > ul > li:first-child {
    border-color:var(--bh-brand-primary-light);
  }
}

.header-wrapper {
  position:relative;
  background-color:var(--neutral-white);
}

.header-wrapper .header {
  justify-content:space-between;
}

.header-wrapper .btn.parent-container-fit.header{
  justify-content:space-between;
}

@media (min-width: 1024px) {
  .header-wrapper .header {
    display:flex;
  }
}

@media (min-width: 1024px) {
  .header-wrapper .header {
    align-items:center;
  }
}

.header-wrapper .header-mobile-controls-organizer {
  display:flex;
}

.header-wrapper .header-mobile-controls-organizer {
  align-items:center;
}

.header-wrapper .header-mobile-controls-organizer {
  justify-content:space-between;
}

.header-wrapper .header-mobile-controls-organizer {
  gap:1px;
}

.header-wrapper .header-mobile-controls-organizer {
  padding-top:1rem;
  padding-bottom:1rem;
}

.header-wrapper .btn.parent-container-fit.header-mobile-controls-organizer{
  justify-content:space-between;
}

@media (min-width: 1024px) {
  .header-wrapper .header-mobile-controls-organizer {
    padding-top:0px;
    padding-bottom:0px;
  }
}

.header-wrapper .header-logo-wrapper {
  display:inline-block;
}

@media (min-width: 1024px) {
  .header-wrapper .header-logo-wrapper {
    padding-right:1rem;
  }
}

@media (min-width: 1280px) {
  .header-wrapper .header-logo-wrapper {
    padding-right:2.5rem;
  }
}

@media (min-width: 2180px) {
  .header-wrapper .header-logo-wrapper {
    padding-right:4rem;
  }
}

.header-wrapper .header-logo-wrapper {
  transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.header-wrapper .header-logo-wrapper {
  transition-duration:300ms;
}

.header-wrapper .header-logo-wrapper:hover{
      opacity:0.8;
    }

@media (min-width: 1024px) {
  .header-wrapper .header-mobile-controls-section {
    display:none;
  }
}

.header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
  display:inline-flex;
}

.header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
  min-height:29px;
}

.header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
  min-width:29px;
}

.header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
  transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
  cursor:pointer;
}

.header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
  align-items:center;
}

.header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
  justify-content:center;
}

.header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
  border-width:0px;
}

.header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
  background-color:var(--neutral-white);
}

.header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
  transition-duration:300ms;
}

@media (min-width: 1024px) {
  .header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
    min-height:44px;
  }
}

@media (min-width: 1024px) {
  .header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
    min-width:44px;
  }
}

.header-wrapper .header-mobile-controls-hamburger-wrapper {
  margin-left:0px;
  margin-right:0px;
}

@media (min-width: 1024px){

.header-wrapper {
  }
    .header-wrapper ghs-search-bar{
      width:calc(100% - 44px);
    }
  }

.header-wrapper .header-links-master-section {
  display:flex;
}

.header-wrapper .header-links-master-section {
  flex-direction:column;
}

@media (min-width: 1024px) {
  .header-wrapper .header-links-master-section {
    display:block;
  }
}

@media (min-width: 1024px) {
  .header-wrapper .header-links-master-section {
    width:100%;
  }
}

.header-wrapper .header-dropdown-menu-section {
  display:none;
}

.header-wrapper .header-dropdown-menu-section {
  gap:1.5rem;
}

.header-wrapper .header-dropdown-menu-section {
  font-weight:var(--fw-semibold);
}

@media (min-width: 1280px) {
  .header-wrapper .header-dropdown-menu-section {
    font-size:var(--fs-base);
    line-height:var(--lh-base);
  }
}

.header-wrapper .header-dropdown-menu-section{
  }

@media (min-width: 1024px) {
  .header-wrapper .header-dropdown-menu-section {
    display:flex;
  }
}

@media (min-width: 1024px) {
  .header-wrapper .header-dropdown-menu-section {
    justify-content:space-between;
  }
}

@media (min-width: 1024px) {
  .header-wrapper .header-dropdown-menu-section {
    font-size:var(--fs-sm);
    line-height:var(--lh-sm);
  }
}

.header-wrapper .header-dropdown-menu-section{
  }

@media (min-width: 1024px) {
  .header-wrapper .header-dropdown-menu-section {
    border-width:0px;
  }
}

@media (min-width: 1024px) {
  .header-wrapper .header-dropdown-menu-section {
    border-top-width:1px;
  }
}

@media (min-width: 1024px) {
  .header-wrapper .header-dropdown-menu-section {
    border-style:solid;
  }
}

.header-wrapper .header-dropdown-actions-section {
  display:flex;
}

.header-wrapper .header-dropdown-actions-section {
  gap:1.5rem;
}

.header-wrapper .header-dropdown-actions-section {
  vertical-align:middle;
}

.header-wrapper .hamburger-expanded .header-dropdown-menu-section {
  display:block;
}

.header-wrapper .hamburger-expanded .header-dropdown-menu-section{
  }

@media (min-width: 1024px) {
  .header-wrapper .hamburger-expanded .header-dropdown-menu-section {
    display:flex;
  }
}

@media (min-width: 1024px) {
  .header-wrapper .hamburger-expanded .header-dropdown-menu-section {
    justify-content:flex-end;
  }
}

.header-wrapper .header-button-wrapper {
  margin-top:0.75rem;
}

@media (min-width: 1024px) {
  .header-wrapper .header-button-wrapper {
    margin-top:0px;
    margin-bottom:0px;
  }
}

@media (min-width: 1024px) {
  .header-wrapper .header-button-wrapper {
    display:flex;
  }
}

@media (min-width: 1024px) {
  .header-wrapper .header-button-wrapper {
    flex-direction:column;
  }
}

@media (min-width: 1024px) {
  .header-wrapper .header-button-wrapper {
    justify-content:center;
  }
}

.header-wrapper .header-utilities-section {
  display:none;
}

.header-wrapper .header-utilities-section{
  }

@media (min-width: 1024px) {
  .header-wrapper .header-utilities-section {
    display:flex;
  }
}

@media (min-width: 1024px) {
  .header-wrapper .header-utilities-section {
    align-items:center;
  }
}

@media (min-width: 1024px) {
  .header-wrapper .header-utilities-section {
    justify-content:flex-end;
  }
}

@media (min-width: 1024px) {
  .header-wrapper .header-utilities-section {
    gap:1rem;
  }
}

@media (min-width: 1280px) {
  .header-wrapper .header-utilities-section {
    gap:1.75rem;
  }
}

.header-wrapper .hamburger-expanded .header-utilities-section {
  margin-bottom:0.625rem;
}

.header-wrapper .hamburger-expanded .header-utilities-section {
  display:block;
}

.header-wrapper .hamburger-expanded .header-utilities-section{
  }

@media (min-width: 1024px) {
  .header-wrapper .hamburger-expanded .header-utilities-section {
    margin-bottom:0px;
  }
}

@media (min-width: 1024px) {
  .header-wrapper .hamburger-expanded .header-utilities-section {
    display:flex;
  }
}

@media (min-width: 1024px) {
  .header-wrapper .hamburger-expanded .header-utilities-section {
    justify-content:flex-end;
  }
}

.header-wrapper .hamburger-expanded .header-utilities-link {
  margin-bottom:1.75rem;
}

@media (min-width: 1024px) {
  .header-wrapper .hamburger-expanded .header-utilities-link {
    margin-bottom:0px;
  }
}

@media (min-width: 1024px) {
  .header-wrapper .search-expanded .header-utilities-link, .header-wrapper .search-expanded
    .header-utilities-section
    .header-utilities-link-slot-wrapper {
    display:none;
  }
}

.header-wrapper .desktop-search-control {
  display:none;
}

.header-wrapper .desktop-search-control {
  min-width:44px;
}

.header-wrapper .desktop-search-control {
  cursor:pointer;
}

.header-wrapper .desktop-search-control {
  background-color:var(--neutral-white);
}

.header-wrapper .desktop-search-control {
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
}

.header-wrapper .desktop-search-control {
  font-weight:var(--fw-medium);
}

@media (min-width: 1024px) {
  .header-wrapper .desktop-search-control {
    display:flex;
  }
}

@media (min-width: 1024px) {
  .header-wrapper .desktop-search-control {
    align-items:center;
  }
}

@media (min-width: 1024px) {
  .header-wrapper .desktop-search-control {
    gap:0.5rem;
  }
}

@media (min-width: 1024px) {
  .header-wrapper .desktop-search-control {
    padding-left:0.75rem;
  }
}

.header-wrapper .desktop-search-control{
  }

@media (min-width: 1024px) {
  .header-wrapper .desktop-search-control {
    border-width:0px;
  }
}

@media (min-width: 1024px) {
  .header-wrapper .desktop-search-control {
    border-left-width:1px;
  }
}

@media (min-width: 1024px) {
  .header-wrapper .desktop-search-control {
    border-style:solid;
  }
}

@media (min-width: 1280px) {
  .header-wrapper .desktop-search-control {
    padding-left:1.75rem;
  }
}

.header-wrapper .desktop-search-control ghs-icon[name='close'] {
  display:none;
}

.header-wrapper .search-expanded .desktop-search-control {
  min-height:44px;
}

.header-wrapper .search-expanded .desktop-search-control {
  min-width:44px;
}

@media (min-width: 1024px) {
  .header-wrapper .search-expanded .desktop-search-control {
    position:absolute;
  }
}

@media (min-width: 1024px) {
  .header-wrapper .search-expanded .desktop-search-control {
    top:1.25rem;
  }
}

@media (min-width: 1024px) {
  .header-wrapper .search-expanded .desktop-search-control {
    margin-bottom:0px;
  }
}

@media (min-width: 1024px) {
  .header-wrapper .search-expanded .desktop-search-control {
    justify-content:center;
  }
}

@media (min-width: 1024px) {
  .header-wrapper .search-expanded .desktop-search-control {
    border-color:var(--neutral-transparent);
  }
}

@media (min-width: 1024px) {
  .header-wrapper .search-expanded .desktop-search-control {
    padding-left:0.5rem;
  }
}

.header-wrapper .search-expanded .desktop-search-control .label, .header-wrapper .search-expanded .desktop-search-control ghs-icon[name='search'] {
  display:none;
}

.header-wrapper .header-search-wrapper {
  display:none;
}

.header-wrapper .header hr{
  }

.header-wrapper .header hr {
  margin-left:-1.25rem;
  margin-right:-1.25rem;
}

.header-wrapper .header hr {
  margin-top:0px;
  margin-bottom:0px;
}

.header-wrapper .header hr {
  display:none;
}

.header-wrapper .header hr {
  height:1px;
}

.header-wrapper .header hr {
  border-style:none;
}

@media (min-width: 1024px) {
  .header-wrapper .header hr {
    display:none;
  }
}

.header-wrapper .hamburger-expanded hr, .header-wrapper .search-expanded hr {
  display:block;
}

@media (min-width: 1024px) {
  .header-wrapper .hamburger-expanded hr, .header-wrapper .search-expanded hr {
    display:none;
  }
}

.hamburger-check {
  position:absolute;
  top:1.25rem;
  right:1.25rem;
  height:1.5rem;
  width:1.5rem;
  opacity:0;
}

.hamburger-check:checked ~ hr {
  display:block;
}

@media (min-width: 1024px) {
  .hamburger-check:checked ~ hr {
    display:none;
  }
}

.hamburger-check:checked ~ .header-links-master-section .header-utilities-section {
  margin-bottom:0.625rem;
}

.hamburger-check:checked ~ .header-links-master-section .header-utilities-section {
  display:block;
}

.hamburger-check:checked ~ .header-links-master-section .header-utilities-section{
    }

@media (min-width: 1024px) {
  .hamburger-check:checked ~ .header-links-master-section .header-utilities-section {
    margin-bottom:0px;
  }
}

@media (min-width: 1024px) {
  .hamburger-check:checked ~ .header-links-master-section .header-utilities-section {
    display:flex;
  }
}

@media (min-width: 1024px) {
  .hamburger-check:checked ~ .header-links-master-section .header-utilities-section {
    justify-content:flex-end;
  }
}

.hamburger-check:checked ~ .header-links-master-section .header-utilities-link {
  margin-bottom:0.75rem;
}

@media (min-width: 1024px) {
  .hamburger-check:checked ~ .header-links-master-section .header-utilities-link {
    margin-bottom:0px;
  }
}

.header-mobile-top-links.search-expanded, .header-mobile-top-links.hamburger-expanded {
  display:none;
}

.header-utilities-section {
  display:flex;
}

.header-utilities-section.mobile {
  justify-content:flex-end;
}

.header-utilities-section.mobile {
  color:var(--neutral-white);
}

.header-utilities-section.mobile a {
  color:var(--neutral-white);
}

.header-wrapper .header-mobile-controls-section {
  display:flex;
}

.header-wrapper .header-mobile-controls-section {
  color:var(--primary-green);
}

.header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
  display:flex;
}

.header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
  flex-direction:column;
}

.header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
  justify-content:space-between;
}

.header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
  border-radius:9999px;
}

.header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
  padding-left:0.5rem;
  padding-right:0.5rem;
}

.header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
  font-weight:var(--fw-bold);
}

.header-wrapper .btn.parent-container-fit.header-mobile-controls-search-wrapper, .header-wrapper .btn.parent-container-fit.header-mobile-controls-hamburger-wrapper{
  justify-content:space-between;
}

@media (min-width: 1024px) {
  .header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
    display:none;
  }
}

.header-wrapper .header-mobile-controls-search-wrapper:hover, .header-wrapper .header-mobile-controls-hamburger-wrapper:hover {
  color:var(--primary-green-light-1);
}

.header-wrapper .header-mobile-controls-hamburger-wrapper{
    min-height:44px;
  }

.header-wrapper .header-mobile-controls-hamburger-wrapper ghs-icon {
  position:relative;
}

.header-wrapper .header-mobile-controls-hamburger-wrapper ghs-icon{
      top:-4px;
    }

.header-wrapper .header-mobile-controls-hamburger-wrapper.hamburger-expanded {
  height:2.25rem;
}

.header-wrapper .header-mobile-controls-hamburger-wrapper.hamburger-expanded {
  width:2.25rem;
}

.header-wrapper .header-mobile-controls-hamburger-wrapper.hamburger-expanded {
  align-items:center;
}

.header-wrapper .header-mobile-controls-hamburger-wrapper.hamburger-expanded {
  justify-content:center;
}

.header-wrapper .header-mobile-controls-hamburger-wrapper.hamburger-expanded {
  background-color:var(--primary-green);
}

.header-wrapper .header-mobile-controls-hamburger-wrapper.hamburger-expanded{
      min-height:auto;
    }

.header-wrapper .header-mobile-controls-hamburger-wrapper.hamburger-expanded > ghs-icon {
  position:static;
}

.header-wrapper .header-mobile-controls-hamburger-wrapper.hamburger-expanded > ghs-icon {
  color:var(--neutral-white);
}

.header-wrapper .header-mobile-controls-search-wrapper{
    min-height:44px;
    color:var(--neutral-black);
  }

.header-wrapper .header-mobile-controls-search-wrapper ghs-icon {
  position:relative;
}

.header-wrapper .header-mobile-controls-search-wrapper ghs-icon{
      top:3px;
    }

.header-wrapper .header-mobile-controls-search-wrapper.search-expanded {
  height:2.25rem;
}

.header-wrapper .header-mobile-controls-search-wrapper.search-expanded {
  width:2.25rem;
}

.header-wrapper .header-mobile-controls-search-wrapper.search-expanded {
  align-items:center;
}

.header-wrapper .header-mobile-controls-search-wrapper.search-expanded {
  justify-content:center;
}

.header-wrapper .header-mobile-controls-search-wrapper.search-expanded {
  background-color:var(--primary-green);
}

.header-wrapper .header-mobile-controls-search-wrapper.search-expanded{
      min-height:auto;
    }

.header-wrapper .header-mobile-controls-search-wrapper.search-expanded > ghs-icon {
  position:static;
}

.header-wrapper .header-mobile-controls-search-wrapper.search-expanded > ghs-icon {
  color:var(--neutral-white);
}

:host([site='GHS']) .header-mobile-top-links {
  background-color:var(--primary-blue);
}

:host([site='GHS']) .search-expanded .header-search-wrapper {
  margin-left:auto;
}

:host([site='GHS']) .search-expanded .header-search-wrapper {
  display:block;
}

:host([site='GHS']) .search-expanded .header-search-wrapper {
  padding-bottom:1.5rem;
}

@media (min-width: 1024px) {
  :host([site='GHS']) .search-expanded .header-search-wrapper {
    width:80%;
  }
}

@media (min-width: 1024px) {
  :host([site='GHS']) .search-expanded .header-search-wrapper {
    padding-right:3.5rem;
  }
}

@media (min-width: 1024px) {
  :host([site='GHS']) .search-expanded .header-search-wrapper {
    padding-bottom:0px;
  }
}

:host([site='GHS']) .header-wrapper{
    box-shadow:var(--brand-shadow);
  }

:host([site='GHS']) .header-wrapper .header-mobile-controls-hamburger-wrapper {
  color:var(--primary-green);
}

:host([site='GHS']) .header-wrapper .header {
  font-family:var(--ff-display);
}

:host([site='GHS']) .header-wrapper .header {
  color:var(--primary-blue);
}

@media (min-width: 1024px) {
  :host([site='GHS']) .header-wrapper .header {
    height:86px;
  }
}

@media (min-width: 1024px) {
  :host([site='GHS']) .header-wrapper .header {
    min-height:5.25rem;
  }
}

@media (min-width: 1024px) {
  :host([site='GHS']) .header-wrapper .header {
    padding-top:1.25rem;
    padding-bottom:1.25rem;
  }
}

:host([site='GHS']) .header-wrapper .header .header-logo-wrapper {
  width:8rem;
}

@media (min-width: 1024px) {
  :host([site='GHS']) .header-wrapper .header .header-logo-wrapper {
    width:9rem;
  }
}

@media (min-width: 1280px) {
  :host([site='GHS']) .header-wrapper .header .header-logo-wrapper {
    width:13rem;
  }
}

@media (min-width: 1024px) {
  :host([site='GHS']) .header-wrapper .header-dropdown-menu-section {
    border-color:var(--neutral-gray-4);
  }
}

:host([site='GHS']) .header-wrapper .desktop-search-control {
  border-left-width:0px;
}

:host([site='GHS']) .header-wrapper .desktop-search-control {
  padding-left:0.5rem;
}

:host([site='GHS']) .header-wrapper .desktop-search-control {
  font-family:var(--ff-display);
}

:host([site='GHS']) .header-wrapper .desktop-search-control {
  color:var(--primary-green);
}

@media (min-width: 1024px) {
  :host([site='GHS']) .header-wrapper .desktop-search-control {
    border-color:var(--neutral-gray-4);
  }
}

:host([site='GHS']) .header-wrapper .desktop-search-control ghs-icon[name='search'] {
  color:var(--primary-green);
}

:host([site='GHS']) .header-wrapper .desktop-search-control:hover, :host([site='GHS']) .header-wrapper .desktop-search-control:hover ghs-icon[name='search'] {
  color:var(--primary-green-light-1);
}

:host([site='GHS']) .header-wrapper .search-expanded .desktop-search-control ghs-icon[name='close'] {
  display:block;
}

:host([site='GHS']) .header-wrapper .search-expanded .desktop-search-control ghs-icon[name='close'] {
  color:var(--primary-green);
}

:host([site='GHS']) .header-wrapper .header-button-wrapper {
  margin-top:0px;
  margin-bottom:0px;
}

:host([site='GHS']) .header-wrapper .header-button-wrapper {
  padding-bottom:1.75rem;
}

@media (min-width: 1024px) {
  :host([site='GHS']) .header-wrapper .header-button-wrapper {
    padding-top:0px;
    padding-bottom:0px;
  }
}

:host([site='GHS']) .header-wrapper .header hr{
    }

:host([site='GHS']) .header-wrapper .header hr {
  background-color:var(--neutral-gray-4);
}

:host([site='GHS']) .header-dropdown-buttons ::slotted(*) {
  margin-left:-1rem;
  margin-right:-1rem;
}

:host([site='GHS']) .header-dropdown-buttons ::slotted(*) {
  display:flex;
}

:host([site='GHS']) .header-dropdown-buttons ::slotted(*) {
  flex-wrap:wrap;
}

:host([site='GHS']) .header-dropdown-buttons ::slotted(*) a{
        display:inline-block;
        color:white;
        background-color:black;
      }

:host([site='GHS']) .header-dropdown-buttons a.header-button{
      display:none;
    }

:host([site='BH']) .header-mobile-top-links {
  background-color:var(--bh-brand-primary-dark);
}

:host([site='BH']) ::slotted(.header-button) {
  margin-top:0.5rem;
}

:host([site='BH']) ::slotted(.header-button) {
  margin-bottom:0.5rem;
}

:host([site='BH']) .search-expanded .header-search-wrapper {
  margin-left:auto;
}

:host([site='BH']) .search-expanded .header-search-wrapper {
  display:block;
}

@media (min-width: 1024px) {
  :host([site='BH']) .search-expanded .header-search-wrapper {
    width:66.666667%;
  }
}

@media (min-width: 1024px) {
  :host([site='BH']) .search-expanded .header-search-wrapper {
    padding-right:3.5rem;
  }
}

@media (min-width: 1024px) {
  :host([site='BH']) .search-expanded .header-search-wrapper {
    padding-bottom:0px;
  }
}

:host([site='BH']) .search-expanded .header-search-wrapper {
  position:fixed;
}

:host([site='BH']) .search-expanded .header-search-wrapper {
  left:0px;
}

:host([site='BH']) .search-expanded .header-search-wrapper {
  top:0px;
}

:host([site='BH']) .search-expanded .header-search-wrapper {
  z-index:50;
}

:host([site='BH']) .search-expanded .header-search-wrapper {
  display:block;
}

:host([site='BH']) .search-expanded .header-search-wrapper {
  width:100%;
}

:host([site='BH']) .search-expanded .header-search-wrapper {
  background-color:var(--neutral-white);
}

:host([site='BH']) .search-expanded .header-search-wrapper {
  padding-left:1rem;
  padding-right:1rem;
}

:host([site='BH']) .search-expanded .header-search-wrapper {
  padding-bottom:1.5rem;
}

:host([site='BH']) .search-expanded .header-search-wrapper {
  padding-top:1rem;
}

@media (min-width: 768px) {
  :host([site='BH']) .search-expanded .header-search-wrapper {
    padding-left:4rem;
    padding-right:4rem;
  }
}

@media (min-width: 768px) {
  :host([site='BH']) .search-expanded .header-search-wrapper {
    padding-bottom:4rem;
  }
}

:host([site='BH']) .search-expanded .header-search-wrapper{
    z-index:500;
  }

:host([site='BH']) .header-wrapper{
    box-shadow:var(--brand-shadow);
  }

:host([site='BH']) .header-wrapper .header-mobile-controls-hamburger-wrapper {
  color:var(--bh-brand-primary-default);
}

:host([site='BH']) .header-wrapper .header {
  font-family:var(--bh-ff-body);
}

:host([site='BH']) .header-wrapper .header {
  color:var(--bh-brand-primary-default);
}

:host([site='BH']) .header-wrapper .header-logo-wrapper {
  width:8rem;
}

@media (min-width: 1024px) {
  :host([site='BH']) .header-wrapper .header-logo-wrapper {
    width:16rem;
  }
}

:host([site='BH']) .header-wrapper .header-mobile-controls-section {
  color:var(--bh-brand-primary-default);
}

:host([site='BH']) .header-wrapper .header-mobile-controls-search-wrapper.search-expanded {
  background-color:var(--bh-brand-primary-lightest);
}

:host([site='BH']) .header-wrapper .header-mobile-controls-search-wrapper.search-expanded > ghs-icon {
  color:var(--bh-neutral-black);
}

:host([site='BH']) .header-wrapper .header-mobile-controls-hamburger-wrapper.hamburger-expanded {
  background-color:var(--bh-brand-primary-lightest);
}

:host([site='BH']) .header-wrapper .header-mobile-controls-hamburger-wrapper.hamburger-expanded > ghs-icon {
  color:var(--bh-neutral-black);
}

:host([site='BH']) .header-wrapper .header-dropdown-menu-section {
  gap:0.25rem;
}

@media (min-width: 1024px) {
  :host([site='BH']) .header-wrapper .header-dropdown-menu-section {
    gap:2rem;
  }
}

@media (min-width: 1024px) {
  :host([site='BH']) .header-wrapper .header-dropdown-menu-section {
    border-color:var(--bh-neutral-default);
  }
}

:host([site='BH']) .header-wrapper .desktop-search-control {
  font-family:var(--bh-ff-body);
}

:host([site='BH']) .header-wrapper .desktop-search-control {
  color:var(--bh-brand-primary-dark);
}

@media (min-width: 1024px) {
  :host([site='BH']) .header-wrapper .desktop-search-control {
    border-color:var(--bh-neutral-default);
  }
}

:host([site='BH']) .header-wrapper .desktop-search-control ghs-icon[name='search'] {
  color:var(--bh-brand-primary-default);
}

:host([site='BH']) .header-wrapper .desktop-search-control:hover, :host([site='BH']) .header-wrapper .desktop-search-control:hover ghs-icon[name='search'] {
  color:var(--bh-brand-primary-light);
}

@media (min-width: 1024px) {
  :host([site='BH']) .header-wrapper .search-expanded .desktop-search-control {
    min-height:22px;
  }
}

:host([site='BH']) .header-wrapper .search-expanded .desktop-search-control ghs-icon[name='close'] {
  display:block;
}

:host([site='BH']) .header-wrapper .search-expanded .desktop-search-control ghs-icon[name='close'] {
  color:var(--bh-brand-primary-default);
}

:host([site='BH']) .header-wrapper .header-button-wrapper, :host([site='BH']) .header-wrapper .header-button-wrapper > *, :host([site='BH']) .header-wrapper .header-button-wrapper > * > * {
  min-height:44px;
}

:host([site='BH']) .header-wrapper .header hr{
    }

:host([site='BH']) .header-wrapper .header hr {
  background-color:var(--bh-neutral-default);
}

@media (min-width: 1024px) {
  :host([site='BH']):host([logo-variant='bhLogoBellinRun']) .header-wrapper .header-logo-wrapper {
    width:8rem;
  }
}

@media (min-width: 1024px) {
  :host([site='BH']):host([logo-variant='bhLogoBellinRun']) .header-wrapper .header-logo-wrapper {
    padding-top:0.5rem;
    padding-bottom:0.5rem;
  }
}

@media (min-width: 1280px) {
  :host([site='BH']):host([logo-variant='bhLogoBellinRun']) .header-wrapper .header-logo-wrapper {
    width:11rem;
  }
}

.ghs-logo {
  display:block;
}

.ghs-logo .svg {
  width:24rem;
}

:host([logo-variant='bhLogoBellinRunWhite']) {
  background-color:var(--bh-brand-primary-default);
  padding-left:1.25rem;
  padding-right:1.25rem;
  padding-top:0.25rem;
  padding-bottom:0.25rem;
}

:host {
  display:inline-block;
}

.phone-contact {
  position:relative;
  display:flex;
  align-items:center;
  font-family:var(--ff-display);
  font-weight:var(--fw-bold);
  color:var(--primary-blue);
  text-decoration-line:none;
}

.phone-contact.normal {
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
}

.phone-contact.small {
  font-size:var(--fs-xs);
  line-height:var(--lh-xs);
}

.phone-contact:hover {
  color:var(--primary-blue-light-2);
}

ghs-icon {
  margin-right:0.25rem;
}

.phone-contact.header {
  color:var(--neutral-white);
}

.phone-contact.header:hover{
  color:var(--neutral-gray-4);
}

.static-container {
  margin-left:auto;
  margin-right:auto;
  display:block;
  max-width:100vw;
  padding-left:1.5rem;
  padding-right:1.5rem;
  font-family:var(--ff-body);
}

.static-container.header {
  display:flex;
  flex-direction:column;
}

@media (min-width: 1024px) {
  .static-container.header {
    flex-direction:row;
  }
}

@media (min-width: 640px){
  .static-container {
    max-width:640px;
  }
}

@media (min-width: 768px){
  .static-container {
    max-width:768px;
  }
}

@media (min-width: 1024px){
  .static-container {
    max-width:1024px;
  }
}

@media (min-width: 1280px){
  .static-container {
    max-width:1280px;
  }
}

@media (min-width: 1360px){
  .static-container {
    max-width:1360px;
  }
}

@media (min-width: 2180px){
  .static-container {
    max-width:2180px;
  }
}

:host {
  display:block;
}

.header-wrapper {
  width:100%;
}

@media (min-width: 768px) {
  .only-mobile {
    display:none !important;
  }
}

.only-desktop {
  display:none !important;
}

@media (min-width: 768px) {
  .only-desktop {
    display:flex !important;
  }
}
`;